(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-fantastick-configurator]";
  var API_NAME = "FantastickConfiguratorUniversal";
  var API_VERSION = "7.7";
  var DEFAULT_CANVAS_WIDTH = 1200;
  var DEFAULT_CANVAS_HEIGHT = 800;
  var DEFAULT_MAX_TEXT_CHARS = 14;
  var SHARED_IMAGE_CACHE = window.__fantastickConfiguratorImageCache || new Map();

  window.__fantastickConfiguratorImageCache = SHARED_IMAGE_CACHE;

  if (window[API_NAME] && window[API_NAME].version === API_VERSION) {
    window[API_NAME].initAll(document);
    return;
  }

  if (window[API_NAME] && typeof window[API_NAME].destroyAll === "function") {
    window[API_NAME].destroyAll(document);
  }

  var DEFAULT_THREAD_COLORS = [
    { key: "fallback-orange", name: "Orange", fill: "#f28a2f" },
    { key: "fallback-red", name: "Rot", fill: "#d23434" },
    { key: "fallback-rose", name: "Rosé", fill: "#de6e8a" },
    { key: "fallback-green", name: "Grün", fill: "#50965a" },
    { key: "fallback-blue", name: "Blau", fill: "#3468c6" },
    { key: "fallback-navy", name: "Navy", fill: "#243666" },
    { key: "fallback-gray", name: "Grau", fill: "#5f5f5f" },
    { key: "fallback-black", name: "Schwarz", fill: "#191919" }
  ];

  var DEFAULT_FONTS = [
    { key: "fallback-classic", name: "Klassisch", family: "Georgia", weight: "400", style: "normal" },
    { key: "fallback-clear", name: "Klar", family: "Arial", weight: "600", style: "normal" }
  ];

  var DEFAULT_LAYOUT_BASE = {
    center: {
      text: {
        xRel: 0.50,
        yRel: 0.78,
        angle: 0,
        fontSizeRel: 0.07,
        boxWidthRel: 0.56,
        minFontSize: 13
      },
      coupling: {
        mode: "top",
        motifWidthRel: 0.23,
        gapRel: 0.02,
        xOffsetRel: 0,
        yOffsetRel: 0.05,
        angle: 0
      }
    },
    right: {
      text: {
        xRel: 0.50,
        yRel: 0.50,
        angle: 0,
        fontSizeRel: 0.085,
        boxWidthRel: 0.38,
        minFontSize: 12
      },
      coupling: {
        mode: "left",
        motifWidthRel: 0.20,
        gapRel: 0,
        groupCenterXRel: 0.50,
        groupCenterYRel: 0.50,
        groupAngle: 0,
        xOffsetRel: 0,
        yOffsetRel: 0,
        angle: 0
      }
    }
  };

  var CALIBRATION_BACKGROUND_FIELDS = [
    { path: "background.zoom", label: "Mockup-Zoom", min: 50, max: 200, step: 1, unit: "%", fallback: 100 },
    { path: "background.x", label: "Mockup horizontal", min: -50, max: 50, step: 0.5, unit: "%", fallback: 0 },
    { path: "background.y", label: "Mockup vertikal", min: -50, max: 50, step: 0.5, unit: "%", fallback: 0 }
  ];

  var CALIBRATION_GROUP_FIELDS = [
    { name: "groupX", label: "Gruppe horizontal", min: 0, max: 100, step: 0.5, unit: "%", fallback: 50 },
    { name: "groupY", label: "Gruppe vertikal", min: 0, max: 100, step: 0.5, unit: "%", fallback: 50 },
    { name: "groupZoom", label: "Gruppe Zoom", min: 50, max: 200, step: 1, unit: "%", fallback: 100 },
    { name: "groupRotation", label: "Gruppe drehen", min: -180, max: 180, step: 1, unit: "°", fallback: 0 }
  ];

  var CALIBRATION_MOTIF_FIELDS = [
    { name: "motifSize", label: "Motivgröße", min: 5, max: 60, step: 0.5, unit: "%" },
    { name: "motifGap", label: "Motivabstand", min: -20, max: 30, step: 0.5, unit: "%" },
    { name: "motifX", label: "Motiv horizontal", min: -50, max: 50, step: 0.5, unit: "%" },
    { name: "motifY", label: "Motiv vertikal", min: -50, max: 50, step: 0.5, unit: "%" },
    { name: "motifRotation", label: "Motivdrehung", min: -180, max: 180, step: 1, unit: "°" }
  ];

  function clone(value) {
    return JSON.parse(JSON.stringify(value || {}));
  }

  function deepMerge(target, source) {
    if (!source || typeof source !== "object") return target;

    Object.keys(source).forEach(function (key) {
      var sourceValue = source[key];

      if (sourceValue && typeof sourceValue === "object" && !Array.isArray(sourceValue)) {
        if (!target[key] || typeof target[key] !== "object" || Array.isArray(target[key])) {
          target[key] = {};
        }
        deepMerge(target[key], sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });

    return target;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function rotatePointAround(x, y, centerX, centerY, angleDegrees) {
    var radians = numberOr(angleDegrees, 0) * Math.PI / 180;
    var cosine = Math.cos(radians);
    var sine = Math.sin(radians);
    var deltaX = x - centerX;
    var deltaY = y - centerY;

    return {
      x: centerX + (deltaX * cosine) - (deltaY * sine),
      y: centerY + (deltaX * sine) + (deltaY * cosine)
    };
  }

  function numberOr(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizedOption(value) {
    return String(value || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function safeFilePart(value) {
    return normalizedOption(value) || "personalisiertes-produkt";
  }

  function safePropertyName(value, fallback) {
    var cleaned = String(value || "")
      .replace(/[\[\]\r\n\t]+/g, " ")
      .replace(/\s{2,}/g, " ")
      .trim()
      .slice(0, 60);
    return cleaned || fallback;
  }

  function uniqueId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "fkc-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function parseConfig(root) {
    var element = root.querySelector("[data-fkc-config]");
    if (!element) throw new Error("Konfigurationsdaten fehlen.");
    return JSON.parse(element.textContent);
  }

  function decodePortableJson(value) {
    var raw = String(value || "").trim();
    if (!/^FKC(?:6|7):/.test(raw)) return raw;

    var payload = raw.replace(/^FKC(?:6|7):/, "").replace(/-/g, "+").replace(/_/g, "/");
    while (payload.length % 4) payload += "=";
    var binary = window.atob(payload);

    if (window.TextDecoder) {
      var bytes = Uint8Array.from(binary, function (character) { return character.charCodeAt(0); });
      return new TextDecoder().decode(bytes);
    }

    return decodeURIComponent(Array.prototype.map.call(binary, function (character) {
      return "%" + character.charCodeAt(0).toString(16).padStart(2, "0");
    }).join(""));
  }

  function encodePortableJson(value) {
    var json = JSON.stringify(value);
    var binary;

    if (window.TextEncoder) {
      binary = Array.from(new TextEncoder().encode(json), function (byte) {
        return String.fromCharCode(byte);
      }).join("");
    } else {
      binary = encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, function (_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
      });
    }

    return "FKC7:" + window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  function parseObject(value, label, warnings) {
    if (!value) return null;
    if (typeof value === "object" && !Array.isArray(value)) return clone(value);

    try {
      var parsed = JSON.parse(decodePortableJson(value));
      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        throw new Error("Kein JSON-Objekt");
      }
      return parsed;
    } catch (error) {
      if (warnings) warnings.push(label + " enthält ungültiges JSON und wurde ignoriert.");
      return null;
    }
  }

  function directRootMatches(scope) {
    return scope && typeof scope.matches === "function" && scope.matches(ROOT_SELECTOR);
  }

  function getPath(object, path) {
    return String(path).split(".").reduce(function (current, key) {
      return current && current[key] !== undefined ? current[key] : undefined;
    }, object);
  }

  function setPath(object, path, value) {
    var keys = String(path).split(".");
    var current = object;

    keys.forEach(function (key, index) {
      if (index === keys.length - 1) {
        current[key] = value;
        return;
      }
      if (!current[key] || typeof current[key] !== "object") current[key] = {};
      current = current[key];
    });
  }

  function textDefaults(field, alignment, index) {
    var fallback = alignment === "right"
      ? { x: 50, y: index ? 66 : 50, size: 8.5, rotation: 0, width: 38 }
      : { x: 50, y: index ? 88 : 78, size: 7, rotation: 0, width: 56 };
    var configured = field && field.defaults && field.defaults[alignment];
    var result = deepMerge(fallback, clone(configured));
    if (index > 0 && configured) {
      var firstDefaultY = alignment === "right" ? 50 : 78;
      if (numberOr(configured.y, firstDefaultY) === firstDefaultY) {
        result.y = alignment === "right" ? 66 : 88;
      }
    }
    return result;
  }

  function defaultCalibration(fabricKey, calibrationKey, sizeKey, sizeCalibrationKey, legacyCalibrationKey) {
    return {
      fabricKey: fabricKey,
      calibrationKey: calibrationKey || fabricKey,
      legacyCalibrationKey: legacyCalibrationKey || "",
      sizeKey: sizeKey || "",
      sizeCalibrationKey: sizeCalibrationKey || sizeKey || "",
      background: { zoom: 100, x: 0, y: 0 },
      center: {
        groupX: 50,
        groupY: 50,
        groupZoom: 100,
        groupRotation: 0,
        textX: 50,
        textY: 78,
        textSize: 7,
        textRotation: 0,
        textWidth: 56,
        motifSize: 23,
        motifGap: 2,
        motifX: 0,
        motifY: 5,
        motifRotation: 0
      },
      right: {
        groupX: 50,
        groupY: 50,
        groupZoom: 100,
        textX: 50,
        textY: 50,
        groupRotation: 0,
        textSize: 8.5,
        textRotation: 0,
        textWidth: 38,
        motifSize: 20,
        motifGap: 0,
        motifX: 0,
        motifY: 0,
        motifRotation: 0
      }
    };
  }

  function ensureCalibrationTextLayouts(layout, textFields) {
    ["center", "right"].forEach(function (alignment) {
      var values = layout[alignment] || (layout[alignment] = {});
      var legacyX = alignment === "right" ? numberOr(values.textX, 50) : numberOr(values.textX, 50);
      var legacyY = alignment === "right" ? numberOr(values.textY, 50) : numberOr(values.textY, 78);

      if (values.groupX === undefined) values.groupX = alignment === "right" ? legacyX : 50;
      if (values.groupY === undefined) values.groupY = alignment === "right" ? legacyY : 50;
      if (values.groupZoom === undefined) values.groupZoom = 100;
      if (values.groupRotation === undefined) values.groupRotation = 0;
      if (!values.texts || typeof values.texts !== "object" || Array.isArray(values.texts)) values.texts = {};

      textFields.forEach(function (field, index) {
        var defaults = textDefaults(field, alignment, index);
        var configuredText = values.texts[field.key];
        if (!configuredText) {
          [field.publicKey, "text_" + (index + 1)].some(function (legacyKey) {
            if (legacyKey && values.texts[legacyKey] && typeof values.texts[legacyKey] === "object") {
              configuredText = values.texts[legacyKey];
              return true;
            }
            return false;
          });
        }
        if (index === 0) {
          if (alignment === "center") {
            defaults.x = legacyX;
            defaults.y = legacyY;
          }
          defaults.size = numberOr(values.textSize, defaults.size);
          defaults.rotation = numberOr(values.textRotation, defaults.rotation);
          defaults.width = numberOr(values.textWidth, defaults.width);
        }
        values.texts[field.key] = deepMerge(defaults, clone(configuredText));
      });
    });
    return layout;
  }

  function migrateLegacyCalibrationSource(source) {
    var migrated = clone(source);
    if (migrated.right && typeof migrated.right === "object") {
      if (migrated.right.groupX === undefined && migrated.right.textX !== undefined) {
        migrated.right.groupX = migrated.right.textX;
      }
      if (migrated.right.groupY === undefined && migrated.right.textY !== undefined) {
        migrated.right.groupY = migrated.right.textY;
      }
    }
    return migrated;
  }

  function getCalibrationPayload(bundle, config, warnings) {
    if (!bundle || typeof bundle !== "object" || Array.isArray(bundle)) return null;

    var bundleProductKey = String(bundle.productKey || "");
    var currentProductKey = String(config.productKey || "");
    if (bundleProductKey && currentProductKey && bundleProductKey !== currentProductKey) {
      if (warnings) warnings.push("Das Kalibrierungspaket gehört zu einer anderen Produktvorlage und wurde nicht angewendet.");
      return null;
    }

    var bundleWidth = numberOr(bundle.canvas && bundle.canvas.width, 0);
    var bundleHeight = numberOr(bundle.canvas && bundle.canvas.height, 0);
    var currentWidth = numberOr(config.canvasWidth, 0);
    var currentHeight = numberOr(config.canvasHeight, 0);
    if (
      bundleWidth && bundleHeight && currentWidth && currentHeight
      && (bundleWidth !== currentWidth || bundleHeight !== currentHeight)
    ) {
      if (warnings) warnings.push("Das Kalibrierungspaket verwendet ein anderes Canvas-Format und wurde nicht angewendet.");
      return null;
    }

    var sizes = bundle.sizes && typeof bundle.sizes === "object" && !Array.isArray(bundle.sizes)
      ? bundle.sizes
      : null;
    var flat = null;
    if (bundle.layouts && typeof bundle.layouts === "object" && !Array.isArray(bundle.layouts)) {
      flat = bundle.layouts;
    } else if (bundle.calibrations && typeof bundle.calibrations === "object" && !Array.isArray(bundle.calibrations)) {
      flat = bundle.calibrations;
    } else if (!sizes) {
      flat = bundle;
    }

    return { flat: flat, sizes: sizes };
  }

  function findCalibrationByFabric(container, layout) {
    if (!container || typeof container !== "object") return null;
    var candidateKeys = [layout.calibrationKey, layout.legacyCalibrationKey, layout.fabricKey].filter(Boolean);
    var result = null;
    candidateKeys.some(function (key) {
      if (container[key] && typeof container[key] === "object") {
        result = container[key];
        return true;
      }
      return false;
    });
    return result;
  }

  function mergeCalibrationBundle(layouts, bundle, config, textFields, warnings) {
    var payload = getCalibrationPayload(bundle, config, warnings);
    if (!payload) return 0;
    var appliedCount = 0;

    layouts.forEach(function (layout) {
      var values = null;
      if (payload.sizes && layout.sizeKey) {
        var sizeKeys = [layout.sizeCalibrationKey, layout.sizeKey].filter(Boolean);
        var sizeValues = null;
        sizeKeys.some(function (key) {
          if (payload.sizes[key] && typeof payload.sizes[key] === "object") {
            sizeValues = payload.sizes[key];
            return true;
          }
          return false;
        });
        values = findCalibrationByFabric(sizeValues, layout);
      }
      if (!values) values = findCalibrationByFabric(payload.flat, layout);
      if (!values) return;

      deepMerge(layout, migrateLegacyCalibrationSource(values));
      ensureCalibrationTextLayouts(layout, textFields);
      appliedCount += 1;
    });

    return appliedCount;
  }

  function prepareLayoutOverrides(config, fabrics, sizes, textFields, warnings) {
    var rawLayouts = Array.isArray(config.layoutOverrides) ? config.layoutOverrides : [];
    var baseLayouts = rawLayouts.map(function (rawLayout) {
      var layout = deepMerge(
        defaultCalibration(rawLayout.fabricKey, rawLayout.calibrationKey, "", "", rawLayout.legacyCalibrationKey),
        clone(rawLayout)
      );
      var blockJson = parseObject(rawLayout.calibrationData || rawLayout.calibrationJson, "Eine Farbkalibrierung", warnings);
      delete layout.calibrationData;
      delete layout.calibrationJson;
      if (blockJson) deepMerge(layout, migrateLegacyCalibrationSource(blockJson));
      return layout;
    });

    fabrics.forEach(function (fabric) {
      var existing = baseLayouts.find(function (layout) { return layout.fabricKey === fabric.key; });
      if (!existing) {
        baseLayouts.push(defaultCalibration(fabric.key, fabric.calibrationKey, "", "", fabric.legacyCalibrationKey));
      }
    });

    var layouts = [];
    if (sizes.length) {
      sizes.forEach(function (size) {
        fabrics.forEach(function (fabric) {
          var base = baseLayouts.find(function (layout) { return layout.fabricKey === fabric.key; });
          var layout = deepMerge(
            defaultCalibration(
              fabric.key,
              fabric.calibrationKey,
              size.key,
              size.calibrationKey,
              fabric.legacyCalibrationKey
            ),
            clone(base)
          );
          layout.sizeKey = size.key;
          layout.sizeCalibrationKey = size.calibrationKey || size.key;
          layouts.push(layout);
        });
      });
    } else {
      layouts = baseLayouts;
    }

    var bundle = parseObject(config.calibrationBundle, "Das Kalibrierungs-Paket", warnings);
    if (bundle) mergeCalibrationBundle(layouts, bundle, config, textFields, warnings);
    layouts.forEach(function (layout) { ensureCalibrationTextLayouts(layout, textFields); });
    return layouts;
  }

  function FantastickConfigurator(root, config) {
    this.root = root;
    this.config = config;
    this.logicalWidth = Math.max(600, numberOr(config.canvasWidth, DEFAULT_CANVAS_WIDTH));
    this.logicalHeight = Math.max(400, numberOr(config.canvasHeight, DEFAULT_CANVAS_HEIGHT));
    this.textFields = (Array.isArray(config.textFields) ? config.textFields : [])
      .filter(function (item) { return item && item.key; })
      .slice(0, 2)
      .map(function (item, index) {
        return {
          key: String(item.key),
          publicKey: String(item.publicKey || item.key),
          heading: String(item.heading || "Text " + (index + 1)),
          inputLabel: String(item.inputLabel || "Dein Text"),
          placeholder: String(item.placeholder || "Zum Beispiel: Mia"),
          cartLabel: safePropertyName(item.cartLabel, "Text " + (index + 1)),
          maxChars: clamp(numberOr(item.maxChars, config.maxTextChars || DEFAULT_MAX_TEXT_CHARS), 1, 40),
          required: item.required !== false,
          defaults: clone(item.defaults)
        };
      });

    if (!this.textFields.length) {
      this.textFields.push({
        key: "text_1",
        publicKey: "text_1",
        heading: "Name oder Wunschtext",
        inputLabel: "Dein Text",
        placeholder: "Zum Beispiel: Mia",
        cartLabel: "Name / Wunschtext",
        maxChars: clamp(numberOr(config.maxTextChars, DEFAULT_MAX_TEXT_CHARS), 1, 40),
        required: true,
        defaults: {}
      });
    }

    this.positionSelectorEnabled = config.positionSelectorEnabled !== false && this.textFields.length === 1;
    this.defaultAlignment = config.defaultPosition === "right" ? "right" : "center";
    this.motifEnabled = config.motifEnabled !== false && Array.isArray(config.motifs) && config.motifs.length > 0;
    this.listeners = [];
    this.imageCache = SHARED_IMAGE_CACHE;
    this.backgroundToken = 0;
    this.motifToken = 0;
    this.layoutFrame = 0;
    this.textEntryTimer = 0;
    this.busy = false;
    this.resizeObserver = null;
    this.headerDrawerObserver = null;
    this.previewDialogObserver = null;
    this.previewDialogToken = 0;
    this.previewDialogUrl = "";
    this.previewDialogScale = 1;
    this.previewDialogOpener = null;
    this.previewScrollLock = null;
    this.mobilePreviewMedia = typeof window.matchMedia === "function"
      ? window.matchMedia("(max-width: 899px)")
      : { matches: false };
    this.canvas = null;
    this.backgroundFill = null;
    this.backgroundImage = null;
    this.textObjects = {};
    this.motifObject = null;
    this.warnings = [];

    this.fits = (Array.isArray(config.fits) ? config.fits : []).filter(function (item) {
      return item && item.key && item.variantValue;
    });
    this.fitEnabled = this.fits.length > 0;
    this.automaticSizeMode = config.automaticSizeMode === true;
    this.sizes = (Array.isArray(config.sizes) ? config.sizes : [])
      .filter(function (item) { return item && item.key && item.variantValue; });
    if (!this.automaticSizeMode) this.sizes = this.sizes.slice(0, 3);
    this.sizeEnabled = this.sizes.length > 0;
    this.sizeSpecificLayouts = this.sizeEnabled && !this.automaticSizeMode;
    var usedSizeSlots = {};
    this.sizes.forEach(function (size, index) {
      size.slot = String(size.slot || "size_" + (index + 1));
      size.calibrationKey = String(size.calibrationKey || size.variantValue || size.key);
      if (usedSizeSlots[size.slot]) {
        this.warnings.push("Der Mockup-Slot „" + size.slot + "“ wird bei mehreren Größen verwendet.");
      }
      usedSizeSlots[size.slot] = true;
    }, this);

    this.fabrics = (Array.isArray(config.fabrics) ? config.fabrics : []).filter(function (item) {
      return item && item.key;
    });
    this.motifs = [{ key: "none", label: "Ohne Motiv", imageUrl: "", sizePercent: 100, gap: 0, x: 0, y: 0, rotation: 0 }];
    if (this.motifEnabled) {
      this.motifs = this.motifs.concat(config.motifs.filter(function (item) { return item && item.key; }));
    }
    this.colors = (Array.isArray(config.threadColors) ? config.threadColors : []).filter(function (item) {
      return item && item.key && item.fill;
    });
    this.fonts = (Array.isArray(config.fonts) ? config.fonts : []).filter(function (item) {
      return item && item.key && item.family && item.available !== false;
    });

    if (!this.colors.length) this.colors = clone(DEFAULT_THREAD_COLORS);
    if (!this.fonts.length) this.fonts = clone(DEFAULT_FONTS);

    this.layoutOverrides = prepareLayoutOverrides(config, this.fabrics, this.sizeSpecificLayouts ? this.sizes : [], this.textFields, this.warnings);
    this.savedLayoutOverrides = clone(this.layoutOverrides);
    this.baseCalibrationSignature = JSON.stringify(this.savedLayoutOverrides);
    this.storageKey = "fkc-state-v7:" + String(config.productKey || "product") + ":" + String(config.productId || "0");
    this.legacyStorageKey = "fkc-state-v6:" + String(config.productKey || "product") + ":" + String(config.productId || "0");
    this.calibrationDraftKey = this.storageKey + ":calibration";

    this.state = {
      fitKey: this.fits[0] ? this.fits[0].key : "",
      sizeKey: this.sizes[0] ? this.sizes[0].key : "",
      fabricKey: this.fabrics[0] ? this.fabrics[0].key : "",
      alignKey: "center",
      motifKey: "none",
      previewCollapsed: false,
      textValues: {},
      colorKeys: {},
      fontKeys: {}
    };

    this.textFields.forEach(function (field) {
      this.state.textValues[field.key] = "";
      this.state.colorKeys[field.key] = this.colors[0] ? this.colors[0].key : "";
      this.state.fontKeys[field.key] = this.fonts[0] ? this.fonts[0].key : "";
    }, this);

    this.restoreState();
    this.restoreCalibrationDraft();

    this.elements = {
      form: root.querySelector("[data-fkc-form]"),
      fitBar: root.querySelector("[data-fkc-fit-bar]"),
      sizeBar: root.querySelector("[data-fkc-size-bar]"),
      fabricBar: root.querySelector("[data-fkc-fabric-bar]"),
      previewColumn: root.querySelector("[data-fkc-preview-column]"),
      previewContent: root.querySelector("[data-fkc-preview-content]"),
      canvasWrap: root.querySelector("[data-fkc-canvas-wrap]"),
      canvasElement: root.querySelector("[data-fkc-canvas]"),
      canvasLoading: root.querySelector("[data-fkc-canvas-loading]"),
      previewToggle: root.querySelector("[data-fkc-preview-toggle]"),
      previewZoom: root.querySelector("[data-fkc-preview-zoom]"),
      canvasOpen: root.querySelector("[data-fkc-canvas-open]"),
      zoomDialog: root.querySelector("[data-fkc-zoom-dialog]"),
      zoomViewport: root.querySelector("[data-fkc-zoom-viewport]"),
      zoomStage: root.querySelector("[data-fkc-zoom-stage]"),
      zoomImage: root.querySelector("[data-fkc-zoom-image]"),
      zoomSave: root.querySelector("[data-fkc-zoom-save]"),
      zoomStatus: root.querySelector("[data-fkc-zoom-status]"),
      zoomIn: root.querySelector("[data-fkc-zoom-in]"),
      zoomOut: root.querySelector("[data-fkc-zoom-out]"),
      zoomFit: root.querySelector("[data-fkc-zoom-fit]"),
      zoomLevel: root.querySelector("[data-fkc-zoom-level]"),
      alignCenter: root.querySelector("[data-fkc-align-center]"),
      alignRight: root.querySelector("[data-fkc-align-right]"),
      motifTrack: root.querySelector("[data-fkc-motif-track]"),
      textInputs: Array.from(root.querySelectorAll("[data-fkc-text]")),
      textCounters: Array.from(root.querySelectorAll("[data-fkc-text-counter]")),
      colorSelects: Array.from(root.querySelectorAll("[data-fkc-color]")),
      fontSelects: Array.from(root.querySelectorAll("[data-fkc-font]")),
      addButton: root.querySelector("[data-fkc-add]"),
      selectedPrice: root.querySelector("[data-fkc-selected-price]"),
      status: root.querySelector("[data-fkc-status]"),
      variantNote: root.querySelector("[data-fkc-variant-note]"),
      calibrator: root.querySelector("[data-fkc-calibrator]"),
      calibrationCurrent: root.querySelector("[data-fkc-calibration-current]"),
      calibrationControls: root.querySelector("[data-fkc-calibration-controls]"),
      calibrationOutput: root.querySelector("[data-fkc-calibration-output]"),
      calibrationCopy: root.querySelector("[data-fkc-calibration-copy]"),
      calibrationApplyAll: root.querySelector("[data-fkc-calibration-apply-all]"),
      calibrationApplyPositionsAll: root.querySelector("[data-fkc-calibration-apply-positions-all]"),
      calibrationApplyCompleteAll: root.querySelector("[data-fkc-calibration-apply-complete-all]"),
      calibrationTarget: root.querySelector("[data-fkc-calibration-target]"),
      calibrationScope: root.querySelector("[data-fkc-calibration-scope]"),
      calibrationApplyTarget: root.querySelector("[data-fkc-calibration-apply-target]"),
      calibrationImportInput: root.querySelector("[data-fkc-calibration-import-input]"),
      calibrationImport: root.querySelector("[data-fkc-calibration-import]"),
      calibrationReset: root.querySelector("[data-fkc-calibration-reset]"),
      calibrationStatus: root.querySelector("[data-fkc-calibration-status]")
    };
  }

  FantastickConfigurator.prototype.requireSetup = function () {
    // Do not depend on the Liquid for-loop limit for products above 50 variants.
    var raw = this.config.rawVariants;
    if (Array.isArray(raw) && raw.length > (this.config.variants || []).length) {
      var formatted = this.config.variants || [];
      this.config.variants = raw.map(function (variant) {
        var previous = formatted.find(function (item) { return String(item.id) === String(variant.id); });
        return previous || {
          id: String(variant.id), title: variant.title, options: variant.options,
          available: Boolean(variant.available), price: variant.price,
          priceFormatted: this.formatVariantMoney(variant.price),
          compareAtPrice: variant.compare_at_price,
          compareAtPriceFormatted: variant.compare_at_price ? this.formatVariantMoney(variant.compare_at_price) : null
        };
      }, this);
    }
    if (!window.fabric || !window.fabric.StaticCanvas) {
      throw new Error("Die Vorschau-Bibliothek konnte nicht geladen werden.");
    }

    if (!this.config.productId || !Array.isArray(this.config.variants) || !this.config.variants.length) {
      throw new Error("Bitte im Theme-Editor zuerst das zugehörige Shopify-Produkt auswählen.");
    }

    if (!this.fabrics.length) {
      throw new Error("Für den Konfigurator wurden keine Stofffarben-Blöcke hinterlegt.");
    }

    if (this.fitEnabled) {
      if (!this.elements.fitBar) throw new Error("Bitte auch die Liquid-Datei auf Version 7.6 aktualisieren.");
      if (this.fits.some(function (fit) { return fit.key !== "herren" && fit.key !== "damen"; })) {
        throw new Error("Die Passformoption unterstützt die Werte Herren und Damen. Bitte die Produktoption prüfen.");
      }
      var fitPosition = Number(this.config.fitOptionPosition);
      if (!fitPosition || fitPosition === Number(this.config.variantOptionPosition)
        || (this.sizeEnabled && fitPosition === Number(this.config.sizeOptionPosition))) {
        throw new Error("Passform, Größe und Farbe benötigen unterschiedliche Shopify-Optionspositionen.");
      }
      if (this.fits.some(function (fit) { return !this.getFabricsForFit(fit).length; }, this)) {
        this.warnings.push("Für mindestens eine Passform fehlen eigene Stofffarben-/Mockup-Blöcke. Diese Auswahl ist im Shop gesperrt.");
      }
    }
    var usedCalibrationKeys = new Set();
    this.fabrics.forEach(function (fabric) {
      var key = fabric.calibrationKey || fabric.key;
      if (usedCalibrationKeys.has(key)) {
        throw new Error("Doppelter Kalibrierungsschlüssel: „" + key + "“. Bitte den stabilen Schlüssel im duplizierten Farbblock eindeutig vergeben.");
      }
      usedCalibrationKeys.add(key);
    });

    if (this.sizeEnabled && !this.elements.sizeBar) {
      throw new Error("Die Größenauswahl ist im Konfigurator-Markup nicht vollständig.");
    }

    if (
      this.sizeEnabled
      && numberOr(this.config.sizeOptionPosition, 1) === numberOr(this.config.variantOptionPosition, 1)
    ) {
      throw new Error("Größe und Stofffarbe dürfen nicht auf derselben Shopify-Optionsposition liegen.");
    }

    if (Number(this.config.variantCount) > this.config.variants.length) {
      throw new Error("Nicht alle Produktvarianten konnten geladen werden. Diese Version unterstützt bis zu 250 Varianten pro Produkt; bitte die Einrichtung prüfen.");
    }

    var optional = {
      canvasLoading: true,
      previewToggle: true,
      previewZoom: true,
      canvasOpen: true,
      zoomDialog: true,
      zoomViewport: true,
      zoomStage: true,
      zoomImage: true,
      zoomSave: true,
      zoomStatus: true,
      zoomIn: true,
      zoomOut: true,
      zoomFit: true,
      zoomLevel: true,
      previewContent: true,
      previewColumn: true,
      fitBar: true,
      sizeBar: true,
      selectedPrice: true,
      variantNote: true,
      calibrator: true,
      calibrationCurrent: true,
      calibrationControls: true,
      calibrationOutput: true,
      calibrationCopy: true,
      calibrationApplyAll: true,
      calibrationApplyPositionsAll: true,
      calibrationApplyCompleteAll: true,
      calibrationTarget: true,
      calibrationScope: true,
      calibrationApplyTarget: true,
      calibrationImportInput: true,
      calibrationImport: true,
      calibrationReset: true,
      calibrationStatus: true
    };
    var missing = Object.keys(this.elements).filter(function (key) {
      return !optional[key] && !this.elements[key];
    }, this);

    if (missing.length) throw new Error("Konfigurator-Markup unvollständig: " + missing.join(", "));
    if (
      this.elements.textInputs.length !== this.textFields.length
      || this.elements.textCounters.length !== this.textFields.length
      || this.elements.colorSelects.length !== this.textFields.length
      || this.elements.fontSelects.length !== this.textFields.length
    ) {
      throw new Error("Textfelder und die zugehörigen Schriftgestaltungen sind nicht vollständig gekoppelt.");
    }
  };

  FantastickConfigurator.prototype.listen = function (target, eventName, handler, options) {
    if (!target) return;
    target.addEventListener(eventName, handler, options);
    this.listeners.push(function () {
      target.removeEventListener(eventName, handler, options);
    });
  };

  FantastickConfigurator.prototype.restoreState = function () {
    try {
      var raw = window.sessionStorage.getItem(this.storageKey) || window.sessionStorage.getItem(this.legacyStorageKey);
      var stored = raw ? JSON.parse(raw) : null;
      if (!stored || typeof stored !== "object") return;
      ["fitKey", "sizeKey", "fabricKey", "alignKey", "motifKey"].forEach(function (key) {
        if (typeof stored[key] === "string") this.state[key] = stored[key];
      }, this);
      if (typeof stored.previewCollapsed === "boolean") {
        this.state.previewCollapsed = stored.previewCollapsed;
      }

      ["textValues", "colorKeys", "fontKeys"].forEach(function (mapKey) {
        if (!stored[mapKey] || typeof stored[mapKey] !== "object" || Array.isArray(stored[mapKey])) return;
        this.textFields.forEach(function (field) {
          if (typeof stored[mapKey][field.key] === "string") this.state[mapKey][field.key] = stored[mapKey][field.key];
        }, this);
      }, this);

      var firstField = this.textFields[0];
      if (firstField) {
        if (typeof stored.textValue === "string" && !this.state.textValues[firstField.key]) {
          this.state.textValues[firstField.key] = stored.textValue;
        }
        if (typeof stored.colorKey === "string") this.state.colorKeys[firstField.key] = stored.colorKey;
        if (typeof stored.fontKey === "string") this.state.fontKeys[firstField.key] = stored.fontKey;
      }
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.saveState = function () {
    try {
      window.sessionStorage.setItem(this.storageKey, JSON.stringify(this.state));
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.restoreCalibrationDraft = function () {
    if (!this.config.designMode) return;
    try {
      var raw = window.sessionStorage.getItem(this.calibrationDraftKey);
      var draft = raw ? JSON.parse(raw) : null;
      if (!draft || draft.baseSignature !== this.baseCalibrationSignature || !Array.isArray(draft.layouts)) return;
      this.layoutOverrides = draft.layouts;
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.saveCalibrationDraft = function () {
    if (!this.config.designMode) return;
    try {
      window.sessionStorage.setItem(this.calibrationDraftKey, JSON.stringify({
        baseSignature: this.baseCalibrationSignature,
        layouts: this.layoutOverrides
      }));
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.clearCalibrationDraft = function () {
    try {
      window.sessionStorage.removeItem(this.calibrationDraftKey);
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.getFit = function () {
    if (!this.fitEnabled) return null;
    return this.fits.find(function (fit) { return fit.key === this.state.fitKey; }, this) || this.fits[0];
  };

  FantastickConfigurator.prototype.getFabricsForFit = function (fit) {
    if (!this.fitEnabled) return this.fabrics;
    fit = fit || this.getFit();
    return this.fabrics.filter(function (fabric) { return (fabric.fitKey || "herren") === fit.key; });
  };

  FantastickConfigurator.prototype.getFabric = function () {
    var fabrics = this.getFabricsForFit();
    return fabrics.find(function (item) { return item.key === this.state.fabricKey; }, this) || fabrics[0]
      || { key: "", label: "Keine Farbe eingerichtet", imageUrl: "", swatch: "#eeeeee" };
  };

  FantastickConfigurator.prototype.hasConfiguredMockup = function (fabric, size) {
    if (!this.fitEnabled) return true; // keep legacy behavior without fit option
    return Boolean(fabric && (fabric.imageUrl || (this.sizeSpecificLayouts && size && fabric.imageUrls && fabric.imageUrls[size.slot])));
  };

  FantastickConfigurator.prototype.getSize = function () {
    if (!this.sizeEnabled) return null;
    return this.sizes.find(function (item) { return item.key === this.state.sizeKey; }, this) || this.sizes[0];
  };

  FantastickConfigurator.prototype.getSelectedMockupUrl = function () {
    var fabric = this.getFabric();
    var size = this.getSize();
    if (this.sizeSpecificLayouts && size && fabric.imageUrls && fabric.imageUrls[size.slot]) {
      return fabric.imageUrls[size.slot];
    }
    return fabric.imageUrl || "";
  };

  FantastickConfigurator.prototype.getMotif = function () {
    return this.motifs.find(function (item) { return item.key === this.state.motifKey; }, this) || this.motifs[0];
  };

  FantastickConfigurator.prototype.getColor = function (fieldKey) {
    var key = this.state.colorKeys[fieldKey || this.textFields[0].key];
    return this.colors.find(function (item) { return item.key === key; }) || this.colors[0];
  };

  FantastickConfigurator.prototype.getFont = function (fieldKey) {
    var key = this.state.fontKeys[fieldKey || this.textFields[0].key];
    return this.fonts.find(function (item) { return item.key === key; }) || this.fonts[0];
  };

  FantastickConfigurator.prototype.variantForSelection = function (sizeOption, fabricOption, fitOption) {
    if (!fabricOption || !fabricOption.key) return null;
    fitOption = fitOption || this.getFit();
    if (fitOption && (fabricOption.fitKey || "herren") !== fitOption.key) return null;
    var variants = this.config.variants || [];
    if (!this.sizeEnabled && !this.fitEnabled && fabricOption.variantId) {
      return variants.find(function (variant) { return String(variant.id) === String(fabricOption.variantId); }) || null;
    }
    var colorIndex = numberOr(this.config.variantOptionPosition, 1) - 1;
    var sizeIndex = numberOr(this.config.sizeOptionPosition, 1) - 1;
    var fitIndex = numberOr(this.config.fitOptionPosition, 0) - 1;
    var colorValue = String(fabricOption.variantValue || fabricOption.label).trim();
    var sizeValue = sizeOption ? String(sizeOption.variantValue || sizeOption.label).trim() : "";
    var fitValue = fitOption ? fitOption.variantValue : "";
    var match = function (normalize) {
      return variants.filter(function (variant) {
        var options = variant.options || [];
        var colorMatches = colorIndex < 0
          ? this.getFabricsForFit(fitOption).length === 1
          : normalize(options[colorIndex]) === normalize(colorValue);
        return colorMatches
          && (!sizeOption || normalize(options[sizeIndex]) === normalize(sizeValue))
          && (!fitOption || normalize(options[fitIndex]) === normalize(fitValue));
      }, this);
    }.bind(this);
    var exact = match(function (value) { return String(value == null ? "" : value).trim(); });
    if (exact.length) return exact.length === 1 ? exact[0] : null;
    var normalized = match(normalizedOption);
    if (normalized.length) return normalized.length === 1 ? normalized[0] : null;
    if (sizeOption || fitOption) return null;
    var fallback = variants.filter(function (variant) {
      return (variant.options || []).some(function (value) { return normalizedOption(value) === normalizedOption(colorValue); });
    });
    return fallback.length === 1 ? fallback[0] : null;
  };

  FantastickConfigurator.prototype.variantForFabric = function (fabricOption) {
    return this.variantForSelection(this.getSize(), fabricOption);
  };

  FantastickConfigurator.prototype.getSelectedVariant = function () {
    return this.variantForSelection(this.getSize(), this.getFabric());
  };


  FantastickConfigurator.prototype.availableFabricsForSize = function (size, fit) {
    return this.getFabricsForFit(fit).filter(function (fabric) {
      var variant = this.variantForSelection(size, fabric, fit);
      return variant && variant.available && this.hasConfiguredMockup(fabric, size);
    }, this);
  };

  FantastickConfigurator.prototype.selectionForFit = function (fit) {
    var currentFabric = this.getFabric();
    var sizes = this.sizeEnabled ? [this.getSize()].concat(this.sizes) : [null];
    var result = null;
    sizes.some(function (size) {
      var fabrics = this.availableFabricsForSize(size, fit);
      if (!fabrics.length) return false;
      var matchingColor = fabrics.find(function (fabric) {
        return normalizedOption(fabric.variantValue || fabric.label) === normalizedOption(currentFabric.variantValue || currentFabric.label);
      });
      result = { size: size, fabric: matchingColor || fabrics[0] };
      return true;
    }, this);
    return result;
  };

  FantastickConfigurator.prototype.ensureAvailableInitialSelection = function () {
    if (this.config.designMode) return;
    var current = this.getSelectedVariant();
    if (current && current.available && this.hasConfiguredMockup(this.getFabric(), this.getSize())) return;
    var fits = this.fitEnabled ? [this.getFit()].concat(this.fits) : [null];
    fits.some(function (fit) {
      var selection = this.selectionForFit(fit);
      if (!selection) return false;
      if (fit) this.state.fitKey = fit.key;
      if (selection.size) this.state.sizeKey = selection.size.key;
      this.state.fabricKey = selection.fabric.key;
      return true;
    }, this);
  };

  FantastickConfigurator.prototype.formatVariantMoney = function (amount) {
    return new Intl.NumberFormat(this.config.locale || "de", {
      style: "currency", currency: this.config.currency || "EUR"
    }).format(Number(amount) / 100);
  };

  FantastickConfigurator.prototype.refreshVariantData = async function () {
    if (!this.config.productJsonUrl) return;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(this.config.productJsonUrl, {
        credentials: "same-origin", cache: "no-store", signal: controller.signal,
        headers: { Accept: "application/json" }
      });
      if (!response.ok) throw new Error("Produktdaten sind gerade nicht erreichbar. Bitte erneut versuchen.");
      var product = await response.json();
      if (String(product.id) !== String(this.config.productId) || !Array.isArray(product.variants)) {
        throw new Error("Produktdaten konnten nicht geprüft werden. Bitte die Seite neu laden.");
      }
      this.config.variants = this.config.variants.map(function (previous) {
        var fresh = product.variants.find(function (item) { return String(item.id) === String(previous.id); });
        if (!fresh) return Object.assign({}, previous, { available: false });
        var changedOptions = JSON.stringify(fresh.options) !== JSON.stringify(previous.options);
        return Object.assign({}, previous, {
          available: Boolean(fresh.available) && !changedOptions,
          price: fresh.price,
          priceFormatted: this.formatVariantMoney(fresh.price),
          compareAtPrice: fresh.compare_at_price,
          compareAtPriceFormatted: fresh.compare_at_price ? this.formatVariantMoney(fresh.compare_at_price) : null
        });
      }, this);
      this.renderFabricButtons();
      this.updateControlStates();
    } catch (error) {
      if (error.name === "AbortError") throw new Error("Die Preis- und Bestandsprüfung dauert zu lange. Bitte erneut versuchen.");
      throw error;
    } finally {
      window.clearTimeout(timeout);
    }
  };

  FantastickConfigurator.prototype.chooseInitialState = function () {
    if (this.fitEnabled && !this.fits.some(function (fit) { return fit.key === this.state.fitKey; }, this)) {
      this.state.fitKey = this.fits[0].key;
    }
    if (this.sizeEnabled && !this.sizes.some(function (item) { return item.key === this.state.sizeKey; }, this)) {
      this.state.sizeKey = this.sizes[0].key;
    }
    if (!this.fabrics.some(function (item) { return item.key === this.state.fabricKey; }, this)) {
      this.state.fabricKey = this.fabrics[0].key;
    }
    if (!this.motifEnabled || !this.motifs.some(function (item) { return item.key === this.state.motifKey; }, this)) {
      this.state.motifKey = "none";
    }
    this.textFields.forEach(function (field) {
      if (!this.colors.some(function (item) { return item.key === this.state.colorKeys[field.key]; }, this)) {
        this.state.colorKeys[field.key] = this.colors[0].key;
      }
      if (!this.fonts.some(function (item) { return item.key === this.state.fontKeys[field.key]; }, this)) {
        this.state.fontKeys[field.key] = this.fonts[0].key;
      }
    }, this);
    this.state.alignKey = this.positionSelectorEnabled
      ? (this.state.alignKey === "right" ? "right" : "center")
      : this.defaultAlignment;

    var requestedVariantId = new URLSearchParams(window.location.search).get("variant");
    if (requestedVariantId) {
      var requestedVariant = (this.config.variants || []).find(function (variant) {
        return String(variant.id) === String(requestedVariantId);
      });
      if (requestedVariant) {
        if (this.fitEnabled) {
          var requestedFitValue = (requestedVariant.options || [])[Number(this.config.fitOptionPosition) - 1];
          var matchingFit = this.fits.find(function (fit) { return normalizedOption(fit.variantValue) === normalizedOption(requestedFitValue); });
          if (matchingFit) this.state.fitKey = matchingFit.key;
        }
        if (this.sizeEnabled) {
          var matchingSize = this.sizes.find(function (sizeOption) {
            return this.fabrics.some(function (fabricOption) {
              var variant = this.variantForSelection(sizeOption, fabricOption);
              return variant && String(variant.id) === String(requestedVariantId);
            }, this);
          }, this);
          if (matchingSize) this.state.sizeKey = matchingSize.key;
        }
        var matchingFabric = this.fabrics.find(function (fabricOption) {
          var variant = this.variantForSelection(this.getSize(), fabricOption);
          return variant && String(variant.id) === String(requestedVariantId);
        }, this);
        if (matchingFabric) this.state.fabricKey = matchingFabric.key;
      }
    }

    this.state.fabricKey = this.getFabric().key;
    this.ensureAvailableInitialSelection();
    this.saveState();
  };

  FantastickConfigurator.prototype.setupCanvas = function () {
    this.canvas = new window.fabric.StaticCanvas(this.elements.canvasElement, {
      width: this.logicalWidth,
      height: this.logicalHeight,
      renderOnAddRemove: false,
      enableRetinaScaling: false,
      selection: false
    });

    this.canvas.setDimensions({ width: this.logicalWidth, height: this.logicalHeight });

    this.backgroundFill = new window.fabric.Rect({
      left: 0,
      top: 0,
      width: this.logicalWidth,
      height: this.logicalHeight,
      fill: this.getFabric().swatch || "#f3f4f6",
      selectable: false,
      evented: false,
      objectCaching: false
    });

    this.canvas.add(this.backgroundFill);
    this.textFields.forEach(function (field, index) {
      var initialFont = this.getFont(field.key);
      var textObject = new window.fabric.Text(field.inputLabel || "Text " + (index + 1), {
        originX: "center",
        originY: "center",
        left: this.logicalWidth / 2,
        top: this.logicalHeight / 2,
        fill: this.getColor(field.key).fill,
        fontFamily: initialFont.family,
        fontWeight: initialFont.weight,
        fontStyle: initialFont.style || "normal",
        fontSize: 56,
        selectable: false,
        evented: false,
        objectCaching: false
      });
      this.textObjects[field.key] = textObject;
      this.canvas.add(textObject);
    }, this);
    this.canvas.requestRenderAll();
  };

  FantastickConfigurator.prototype.renderFitButtons = function () {
    if (!this.fitEnabled || !this.elements.fitBar) return;
    var bar = this.elements.fitBar;
    this.fits.forEach(function (fit) {
      var available = Boolean(this.selectionForFit(fit));
      var button = Array.from(bar.children).find(function (node) { return node.dataset.fitKey === fit.key; });
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "fkc__fit-button";
        button.dataset.fitKey = fit.key;
        var label = document.createElement("span"); label.className = "fkc__fit-label";
        var note = document.createElement("span"); note.className = "fkc__fit-note";
        button.append(label, note); bar.appendChild(button);
      }
      button.querySelector(".fkc__fit-label").textContent = fit.label;
      button.querySelector(".fkc__fit-note").textContent = available ? "Verfügbar" : "Nicht verfügbar";
      button.disabled = this.busy || (!available && !this.config.designMode);
      button.classList.toggle("is-active", fit.key === this.state.fitKey);
      button.setAttribute("aria-pressed", String(fit.key === this.state.fitKey));
      button.setAttribute("aria-label", fit.label + (available ? ", Verfügbar" : ", Nicht verfügbar"));
    }, this);
  };

  FantastickConfigurator.prototype.activateFit = async function (fitKey) {
    if (this.busy || !this.fitEnabled || this.state.fitKey === fitKey) return;
    var fit = this.fits.find(function (item) { return item.key === fitKey; });
    if (!fit) return;
    var oldSize = this.getSize();
    var oldFabric = this.getFabric();
    var selection = this.selectionForFit(fit);
    if (!selection && !this.config.designMode) return;
    if (this.config.designMode) {
      var matchingFabrics = this.getFabricsForFit(fit);
      selection = { size: oldSize, fabric: matchingFabrics.find(function (fabric) {
        return normalizedOption(fabric.variantValue || fabric.label) === normalizedOption(oldFabric.variantValue || oldFabric.label);
      }) || matchingFabrics[0] };
    }
    this.closePreviewDialog(false);
    this.state.fitKey = fit.key;
    if (selection && selection.size) this.state.sizeKey = selection.size.key;
    this.state.fabricKey = selection && selection.fabric ? selection.fabric.key : "";
    this.saveState();
    this.setStatus("");
    this.renderFabricButtons();
    this.updateControlStates();
    this.renderCalibrationControls();
    if (selection && selection.fabric && !this.config.designMode) {
      var sizeChanged = oldSize && selection.size && oldSize.key !== selection.size.key;
      var colorChanged = normalizedOption(oldFabric.variantValue || oldFabric.label) !== normalizedOption(selection.fabric.variantValue || selection.fabric.label);
      if (sizeChanged || colorChanged) {
        this.elements.variantNote.textContent = "Für " + fit.label + " haben wir "
          + (selection.size ? "Größe " + selection.size.label + " in " : "") + selection.fabric.label
          + " ausgewählt, weil die bisherige Kombination nicht verfügbar ist. Bitte prüfe deine Auswahl.";
        this.elements.variantNote.classList.remove("is-success");
        this.elements.variantNote.classList.add("is-warning");
      }
    }
    await this.loadSelectedBackground();
  };

  FantastickConfigurator.prototype.renderSizeButtons = function () {
    if (!this.sizeEnabled || !this.elements.sizeBar) return;
    var bar = this.elements.sizeBar;
    var fabric = this.getFabric();
    this.sizes.forEach(function (size) {
      var variant = this.variantForSelection(size, fabric);
      var currentAvailable = Boolean(variant && variant.available && this.hasConfiguredMockup(fabric, size));
      var alternatives = this.availableFabricsForSize(size);
      var available = alternatives.length > 0;
      var button = Array.from(bar.children).find(function (node) { return node.dataset.sizeKey === size.key; });
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "fkc__size-button";
        button.dataset.sizeKey = size.key;
        var copy = document.createElement("span");
        copy.className = "fkc__size-copy";
        ["label", "note"].forEach(function (part) {
          var node = document.createElement("span"); node.className = "fkc__size-" + part; copy.appendChild(node);
        });
        var price = document.createElement("span"); price.className = "fkc__size-price";
        button.append(copy, price); bar.appendChild(button);
      }
      var priceText = variant ? variant.priceFormatted : "";
      if (!currentAvailable && available) {
        var cheapest = alternatives.map(function (color) { return this.variantForSelection(size, color); }, this)
          .sort(function (a, b) { return a.price - b.price; })[0];
        priceText = "ab " + cheapest.priceFormatted;
      }
      var note = currentAvailable ? (size.note || "Verfügbar") : (available ? "Andere Farbe" : "Nicht verfügbar");
      button.querySelector(".fkc__size-label").textContent = size.label;
      button.querySelector(".fkc__size-note").textContent = note;
      button.querySelector(".fkc__size-price").textContent = priceText;
      button.disabled = this.busy || (!available && !this.config.designMode);
      button.classList.toggle("is-unavailable", !available);
      button.setAttribute("aria-label", size.label + ", " + note + (priceText ? ", " + priceText : ""));
      button.setAttribute("aria-pressed", String(size.key === this.state.sizeKey));
    }, this);
  };

  FantastickConfigurator.prototype.renderFabricButtons = function () {
    var bar = this.elements.fabricBar;
    var fabrics = this.getFabricsForFit();
    Array.from(bar.children).forEach(function (button) {
      if (!fabrics.some(function (fabric) { return fabric.key === button.dataset.fabricKey; })) button.remove();
    });
    fabrics.forEach(function (fabric) {
      var variant = this.variantForFabric(fabric);
      var available = Boolean(variant && variant.available && this.hasConfiguredMockup(fabric, this.getSize()));
      var button = Array.from(bar.children).find(function (node) { return node.dataset.fabricKey === fabric.key; });
      if (!button) {
        button = document.createElement("button"); button.type = "button";
        button.className = "fkc__fabric-button"; button.dataset.fabricKey = fabric.key;
        var swatch = document.createElement("span"); swatch.className = "fkc__swatch";
        swatch.style.setProperty("--fkc-swatch", fabric.swatch || "#eeeeee"); swatch.setAttribute("aria-hidden", "true");
        var copy = document.createElement("span"); copy.className = "fkc__fabric-text";
        var label = document.createElement("span"); label.className = "fkc__fabric-label"; label.textContent = fabric.label;
        var note = document.createElement("span"); note.className = "fkc__fabric-availability";
        copy.append(label, note); button.append(swatch, copy); bar.appendChild(button);
      }
      var note = available ? "Verfügbar" : (variant && variant.available ? "Noch nicht verfügbar" : (variant ? "Ausverkauft" : "Nicht verfügbar"));
      button.querySelector(".fkc__fabric-availability").textContent = note;
      button.disabled = this.busy || (!available && !this.config.designMode);
      button.classList.toggle("is-unavailable", !available);
      button.setAttribute("aria-label", fabric.label + ", " + note);
      button.setAttribute("aria-pressed", String(fabric.key === this.state.fabricKey));
    }, this);
  };

  FantastickConfigurator.prototype.renderMotifButtons = function () {
    var fragment = document.createDocumentFragment();

    if (!this.motifEnabled) {
      this.elements.motifTrack.replaceChildren();
      return;
    }

    this.motifs.forEach(function (motif) {
      var button = document.createElement("button");
      var visual = document.createElement("span");
      var label = document.createElement("span");

      button.type = "button";
      button.className = "fkc__motif-button";
      button.dataset.motifKey = motif.key;
      button.disabled = motif.key !== "none" && !motif.imageUrl;
      button.setAttribute("aria-pressed", "false");
      button.setAttribute("aria-label", motif.label + (button.disabled ? " – Motivbild fehlt" : " auswählen"));

      visual.className = "fkc__motif-visual";
      if (motif.key === "none") {
        visual.classList.add("fkc__motif-visual--none");
        visual.textContent = "×";
      } else if (motif.imageUrl) {
        var image = document.createElement("img");
        image.src = motif.imageUrl;
        image.alt = "";
        image.loading = "lazy";
        image.decoding = "async";
        visual.appendChild(image);
      }

      label.className = "fkc__motif-label";
      label.textContent = motif.label;
      button.appendChild(visual);
      button.appendChild(label);
      fragment.appendChild(button);
    });

    this.elements.motifTrack.replaceChildren(fragment);
  };

  FantastickConfigurator.prototype.renderSelects = function () {
    this.elements.colorSelects.forEach(function (select) {
      var fieldKey = select.dataset.fkcTextKey;
      var fragment = document.createDocumentFragment();
      this.colors.forEach(function (color) {
        var option = document.createElement("option");
        option.value = color.key;
        option.textContent = color.name;
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
      select.value = this.state.colorKeys[fieldKey];
    }, this);

    this.elements.fontSelects.forEach(function (select) {
      var fieldKey = select.dataset.fkcTextKey;
      var fragment = document.createDocumentFragment();
      this.fonts.forEach(function (font) {
        var option = document.createElement("option");
        option.value = font.key;
        option.textContent = font.name;
        option.style.fontFamily = font.family;
        option.style.fontWeight = font.weight;
        option.style.fontStyle = font.style || "normal";
        fragment.appendChild(option);
      });
      select.replaceChildren(fragment);
      select.value = this.state.fontKeys[fieldKey];
    }, this);
  };

  FantastickConfigurator.prototype.getTextField = function (fieldKey) {
    return this.textFields.find(function (field) { return field.key === fieldKey; }) || this.textFields[0];
  };

  FantastickConfigurator.prototype.getTextInput = function (fieldKey) {
    return this.elements.textInputs.find(function (input) { return input.dataset.fkcTextKey === fieldKey; }) || null;
  };

  FantastickConfigurator.prototype.getTextCounter = function (fieldKey) {
    return this.elements.textCounters.find(function (counter) { return counter.dataset.fkcTextKey === fieldKey; }) || null;
  };

  FantastickConfigurator.prototype.normalizeText = function (fieldKey, value) {
    var field = this.getTextField(fieldKey);
    var input = this.getTextInput(field.key);
    var counter = this.getTextCounter(field.key);
    var singleLine = String(value || "")
      .replace(/[\r\n\t]+/g, " ")
      .replace(/\s{2,}/g, " ");
    var limited = Array.from(singleLine).slice(0, field.maxChars).join("");

    if (input && input.value !== limited) input.value = limited;
    if (counter) counter.textContent = Array.from(limited).length + "/" + field.maxChars;
    this.state.textValues[field.key] = limited;
    return limited;
  };

  FantastickConfigurator.prototype.getCalibration = function () {
    if (!this.getFabric().key) return ensureCalibrationTextLayouts(defaultCalibration("", ""), this.textFields);
    var calibration = this.layoutOverrides.find(function (layout) {
      return layout
        && layout.fabricKey === this.state.fabricKey
        && (!this.sizeSpecificLayouts || layout.sizeKey === this.state.sizeKey);
    }, this);

    if (calibration) return calibration;
    var fabric = this.getFabric();
    var size = this.sizeSpecificLayouts ? this.getSize() : null;
    calibration = ensureCalibrationTextLayouts(
      defaultCalibration(
        fabric.key,
        fabric.calibrationKey,
        size ? size.key : "",
        size ? size.calibrationKey : "",
        fabric.legacyCalibrationKey
      ),
      this.textFields
    );
    this.layoutOverrides.push(calibration);
    return calibration;
  };

  FantastickConfigurator.prototype.resolveLayout = function () {
    var layoutBase = this.config.layoutBase || DEFAULT_LAYOUT_BASE;
    var rule = clone(layoutBase[this.state.alignKey] || layoutBase.center || DEFAULT_LAYOUT_BASE.center);
    var calibration = this.getCalibration();
    var alignment = this.state.alignKey;
    var values = calibration && calibration[alignment];

    if (values) {
      rule.coupling.motifWidthRel = numberOr(values.motifSize, rule.coupling.motifWidthRel * 100) / 100;
      rule.coupling.gapRel = numberOr(values.motifGap, rule.coupling.gapRel * 100) / 100;
      rule.coupling.xOffsetRel = numberOr(values.motifX, rule.coupling.xOffsetRel * 100) / 100;
      rule.coupling.yOffsetRel = numberOr(values.motifY, rule.coupling.yOffsetRel * 100) / 100;
      rule.coupling.angle = numberOr(values.motifRotation, rule.coupling.angle || 0);
    }

    rule.group = {
      xRel: numberOr(values && values.groupX, alignment === "right" ? values && values.textX : 50) / 100,
      yRel: numberOr(values && values.groupY, alignment === "right" ? values && values.textY : 50) / 100,
      zoom: clamp(numberOr(values && values.groupZoom, 100) / 100, 0.5, 2),
      angle: numberOr(values && values.groupRotation, 0)
    };

    rule.textRules = this.textFields.map(function (field, index) {
      var defaults = textDefaults(field, alignment, index);
      var configured = values && values.texts && values.texts[field.key];
      var textValues = deepMerge(defaults, clone(configured));
      return {
        field: field,
        xRel: numberOr(textValues.x, defaults.x) / 100,
        yRel: numberOr(textValues.y, defaults.y) / 100,
        fontSizeRel: numberOr(textValues.size, defaults.size) / 100,
        angle: numberOr(textValues.rotation, defaults.rotation),
        boxWidthRel: numberOr(textValues.width, defaults.width) / 100,
        minFontSize: 12
      };
    });
    rule.text = rule.textRules[0];

    return rule;
  };

  FantastickConfigurator.prototype.getMotifAdjustment = function () {
    var motif = this.getMotif();
    if (!motif || motif.key === "none") {
      return { scale: 1, gapRelDelta: 0, xOffsetRelDelta: 0, yOffsetRelDelta: 0, angleDelta: 0 };
    }

    return {
      scale: clamp(numberOr(motif.sizePercent, 100) / 100, 0.1, 4),
      gapRelDelta: numberOr(motif.gap, 0) / 100,
      xOffsetRelDelta: numberOr(motif.x, 0) / 100,
      yOffsetRelDelta: numberOr(motif.y, 0) / 100,
      angleDelta: numberOr(motif.rotation, 0)
    };
  };

  FantastickConfigurator.prototype.getBackgroundCalibration = function () {
    var calibration = this.getCalibration();
    var background = calibration && calibration.background;
    return {
      zoom: clamp(numberOr(background && background.zoom, 100), 50, 200),
      x: clamp(numberOr(background && background.x, 0), -50, 50),
      y: clamp(numberOr(background && background.y, 0), -50, 50)
    };
  };

  FantastickConfigurator.prototype.loadImageElement = function (url) {
    if (!url) return Promise.resolve(null);
    if (this.imageCache.has(url)) return this.imageCache.get(url);

    var promise = new Promise(function (resolve, reject) {
      var image = new Image();
      image.crossOrigin = "anonymous";
      image.decoding = "async";
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error("Bild konnte nicht geladen werden.")); };
      image.src = url;
    });

    this.imageCache.set(url, promise);
    return promise;
  };

  FantastickConfigurator.prototype.applyBackgroundLayout = function () {
    if (!this.backgroundImage) return;
    var calibration = this.getBackgroundCalibration();
    var sourceWidth = this.backgroundImage.width || 1;
    var sourceHeight = this.backgroundImage.height || 1;
    var coverScale = Math.max(this.logicalWidth / sourceWidth, this.logicalHeight / sourceHeight);
    var scale = coverScale * (calibration.zoom / 100);

    this.backgroundImage.set({
      originX: "center",
      originY: "center",
      left: (this.logicalWidth / 2) + (this.logicalWidth * calibration.x / 100),
      top: (this.logicalHeight / 2) + (this.logicalHeight * calibration.y / 100),
      scaleX: scale,
      scaleY: scale,
      selectable: false,
      evented: false
    });
    this.backgroundImage.setCoords();
  };

  FantastickConfigurator.prototype.setCanvasLoading = function (isLoading, message) {
    if (!this.elements.canvasLoading) return;
    this.elements.canvasLoading.classList.toggle("is-visible", Boolean(isLoading));
    this.elements.canvasLoading.setAttribute("aria-hidden", String(!isLoading));
    var label = this.elements.canvasLoading.querySelector("[data-fkc-loading-label]");
    if (label && message) label.textContent = message;
  };

  FantastickConfigurator.prototype.loadSelectedBackground = async function () {
    var token = ++this.backgroundToken;
    var fabricOption = this.getFabric();
    var mockupUrl = this.getSelectedMockupUrl();
    this.backgroundFill.set("fill", fabricOption.swatch || "#f3f4f6");

    if (this.backgroundImage) {
      this.canvas.remove(this.backgroundImage);
      this.backgroundImage = null;
    }

    if (!mockupUrl) {
      this.applyLayout();
      this.setCanvasLoading(false);
      return;
    }

    this.setCanvasLoading(true, "Mockup wird geladen …");

    try {
      var imageElement = await this.loadImageElement(mockupUrl);
      if (token !== this.backgroundToken || !imageElement) return;

      this.backgroundImage = new window.fabric.Image(imageElement, {
        selectable: false,
        evented: false,
        objectCaching: false
      });
      this.canvas.insertAt(this.backgroundImage, 1, false);
      this.applyLayout();
    } catch (error) {
      if (token === this.backgroundToken) {
        this.setStatus("Das Mockup konnte nicht geladen werden. Es wird vorübergehend nur die Stofffarbe gezeigt.", "warning");
        this.applyLayout();
      }
    } finally {
      if (token === this.backgroundToken) this.setCanvasLoading(false);
    }
  };

  FantastickConfigurator.prototype.loadSelectedMotif = async function () {
    var token = ++this.motifToken;
    var motif = this.getMotif();

    if (this.motifObject) {
      this.canvas.remove(this.motifObject);
      this.motifObject = null;
    }

    if (!motif || motif.key === "none" || !motif.imageUrl) {
      this.applyLayout();
      return;
    }

    this.setCanvasLoading(true, "Motiv wird geladen …");

    try {
      var imageElement = await this.loadImageElement(motif.imageUrl);
      if (token !== this.motifToken || !imageElement) return;

      this.motifObject = new window.fabric.Image(imageElement, {
        originX: "center",
        originY: "center",
        selectable: false,
        evented: false,
        objectCaching: false
      });
      this.canvas.add(this.motifObject);
      this.applyLayout();
    } catch (error) {
      if (token === this.motifToken) {
        this.state.motifKey = "none";
        this.saveState();
        this.updateControlStates();
        this.setStatus("Das gewählte Motiv konnte nicht geladen werden.", "error");
        this.applyLayout();
      }
    } finally {
      if (token === this.motifToken) this.setCanvasLoading(false);
    }
  };

  FantastickConfigurator.prototype.ensureFontLoaded = async function (fieldKey) {
    var field = this.getTextField(fieldKey);
    var font = this.getFont(field.key);
    if (!document.fonts || typeof document.fonts.load !== "function") return;

    try {
      await Promise.race([
        document.fonts.load(
          (font.style || "normal") + " " + (font.weight || "400") + " 72px \"" + font.family + "\"",
          this.state.textValues[field.key] || field.inputLabel || "Dein Text"
        ),
        wait(1600)
      ]);
    } catch (error) {
      return;
    }
  };

  FantastickConfigurator.prototype.ensureFontsLoaded = async function () {
    await Promise.all(this.textFields.map(function (field) {
      return this.ensureFontLoaded(field.key);
    }, this));
  };

  FantastickConfigurator.prototype.fitText = function (textRule, groupZoom) {
    var field = textRule.field;
    var textObject = this.textObjects[field.key];
    var enteredText = String(this.state.textValues[field.key] || "").trim();
    var displayText = enteredText || field.inputLabel || field.heading || "Dein Text";
    var font = this.getFont(field.key);
    var zoom = clamp(numberOr(groupZoom, 1), 0.5, 2);
    var intendedSize = Math.max(18, textRule.fontSizeRel * this.logicalWidth * zoom);
    var minimumSize = Math.max(10, numberOr(textRule.minFontSize, 12));
    var maximumWidth = Math.max(80, textRule.boxWidthRel * this.logicalWidth * zoom);

    textObject.set({
      text: displayText,
      fill: this.getColor(field.key).fill,
      fontFamily: font.family,
      fontWeight: font.weight || "400",
      fontStyle: font.style || "normal",
      fontSize: intendedSize,
      opacity: enteredText ? 1 : (field.required ? 0.48 : 0),
      scaleX: 1,
      scaleY: 1
    });
    textObject.initDimensions();

    if (textObject.width > maximumWidth) {
      var fittedSize = Math.max(minimumSize, intendedSize * (maximumWidth / textObject.width));
      textObject.set("fontSize", fittedSize);
      textObject.initDimensions();
    }
  };

  FantastickConfigurator.prototype.scaleMotifToWidth = function (targetWidth) {
    if (!this.motifObject) return;
    var naturalWidth = this.motifObject.width || 1;
    var scale = Math.max(0.01, targetWidth / naturalWidth);
    this.motifObject.set({ scaleX: scale, scaleY: scale });
  };

  FantastickConfigurator.prototype.clampObjectToCanvas = function (object) {
    if (!object) return;
    var halfWidth = Math.min(this.logicalWidth / 2, object.getScaledWidth() / 2);
    var halfHeight = Math.min(this.logicalHeight / 2, object.getScaledHeight() / 2);
    object.set({
      left: clamp(object.left, halfWidth, this.logicalWidth - halfWidth),
      top: clamp(object.top, halfHeight, this.logicalHeight - halfHeight)
    });
    object.setCoords();
  };

  FantastickConfigurator.prototype.clampObjectsToCanvasAsGroup = function (objects) {
    var activeObjects = (objects || []).filter(Boolean);
    if (!activeObjects.length) return;

    var bounds = activeObjects.map(function (object) {
      object.setCoords();
      return object.getBoundingRect(true, true);
    });
    var left = Math.min.apply(null, bounds.map(function (box) { return box.left; }));
    var top = Math.min.apply(null, bounds.map(function (box) { return box.top; }));
    var right = Math.max.apply(null, bounds.map(function (box) { return box.left + box.width; }));
    var bottom = Math.max.apply(null, bounds.map(function (box) { return box.top + box.height; }));
    var groupWidth = right - left;
    var groupHeight = bottom - top;
    var deltaX = 0;
    var deltaY = 0;

    if (groupWidth <= this.logicalWidth) {
      if (left < 0) deltaX = -left;
      if (right > this.logicalWidth) deltaX = this.logicalWidth - right;
    } else {
      deltaX = (this.logicalWidth / 2) - ((left + right) / 2);
    }

    if (groupHeight <= this.logicalHeight) {
      if (top < 0) deltaY = -top;
      if (bottom > this.logicalHeight) deltaY = this.logicalHeight - bottom;
    } else {
      deltaY = (this.logicalHeight / 2) - ((top + bottom) / 2);
    }

    if (!deltaX && !deltaY) return;
    activeObjects.forEach(function (object) {
      object.set({ left: object.left + deltaX, top: object.top + deltaY });
      object.setCoords();
    });
  };

  FantastickConfigurator.prototype.transformGroupPoint = function (x, y, group) {
    var referenceX = this.logicalWidth / 2;
    var referenceY = this.logicalHeight / 2;
    var targetX = group.xRel * this.logicalWidth;
    var targetY = group.yRel * this.logicalHeight;
    var scaledX = targetX + ((x - referenceX) * group.zoom);
    var scaledY = targetY + ((y - referenceY) * group.zoom);
    return rotatePointAround(scaledX, scaledY, targetX, targetY, group.angle);
  };

  FantastickConfigurator.prototype.applyCenterLayout = function (rule, motifAdjustment) {
    var activeObjects = [];
    var firstTextObject = null;

    rule.textRules.forEach(function (textRule, index) {
      var textObject = this.textObjects[textRule.field.key];
      var point = this.transformGroupPoint(
        textRule.xRel * this.logicalWidth,
        textRule.yRel * this.logicalHeight,
        rule.group
      );
      textObject.set({
        originX: "center",
        originY: "center",
        left: point.x,
        top: point.y,
        angle: numberOr(textRule.angle, 0) + rule.group.angle
      });
      textObject.setCoords();
      activeObjects.push(textObject);
      if (index === 0) firstTextObject = textObject;
    }, this);

    if (this.motifObject && firstTextObject) {
      var motifWidthRel = Math.max(0.02, rule.coupling.motifWidthRel * motifAdjustment.scale);
      var gapRel = rule.coupling.gapRel + motifAdjustment.gapRelDelta;
      var xOffsetRel = rule.coupling.xOffsetRel + motifAdjustment.xOffsetRelDelta;
      var yOffsetRel = rule.coupling.yOffsetRel + motifAdjustment.yOffsetRelDelta;
      var zoom = rule.group.zoom;

      this.scaleMotifToWidth(motifWidthRel * this.logicalWidth * zoom);
      var motifPoint = rotatePointAround(
        firstTextObject.left + (xOffsetRel * this.logicalWidth * zoom),
        firstTextObject.top
          - (firstTextObject.getScaledHeight() / 2)
          - (gapRel * this.logicalHeight * zoom)
          - (this.motifObject.getScaledHeight() / 2)
          + (yOffsetRel * this.logicalHeight * zoom),
        firstTextObject.left,
        firstTextObject.top,
        rule.group.angle
      );
      this.motifObject.set({
        left: motifPoint.x,
        top: motifPoint.y,
        angle: numberOr(rule.coupling.angle, 0) + motifAdjustment.angleDelta + rule.group.angle
      });
      this.motifObject.setCoords();
      activeObjects.push(this.motifObject);
    }

    this.clampObjectsToCanvasAsGroup(activeObjects);
  };

  FantastickConfigurator.prototype.applyRightLayout = function (rule, motifAdjustment) {
    var groupX = rule.group.xRel * this.logicalWidth;
    var groupY = rule.group.yRel * this.logicalHeight;
    var groupAngle = rule.group.angle;
    var firstRule = rule.textRules[0];
    var firstTextObject = firstRule ? this.textObjects[firstRule.field.key] : null;
    var activeObjects = [];
    var firstBasePoint = firstRule ? this.transformGroupPoint(
      firstRule.xRel * this.logicalWidth,
      firstRule.yRel * this.logicalHeight,
      rule.group
    ) : { x: groupX, y: groupY };

    rule.textRules.slice(1).forEach(function (textRule) {
      var textObject = this.textObjects[textRule.field.key];
      var point = this.transformGroupPoint(
        textRule.xRel * this.logicalWidth,
        textRule.yRel * this.logicalHeight,
        rule.group
      );
      textObject.set({ left: point.x, top: point.y, angle: numberOr(textRule.angle, 0) + groupAngle });
      textObject.setCoords();
      activeObjects.push(textObject);
    }, this);

    if (!firstTextObject) {
      this.clampObjectsToCanvasAsGroup(activeObjects);
      return;
    }

    firstTextObject.set({ left: firstBasePoint.x, top: firstBasePoint.y, angle: numberOr(firstRule.angle, 0) + groupAngle });
    firstTextObject.setCoords();

    if (!this.motifObject) {
      activeObjects.push(firstTextObject);
      this.clampObjectsToCanvasAsGroup(activeObjects);
      return;
    }

    var motifWidthRel = Math.max(0.02, rule.coupling.motifWidthRel * motifAdjustment.scale);
    var gapRel = rule.coupling.gapRel + motifAdjustment.gapRelDelta;
    var xOffsetRel = rule.coupling.xOffsetRel + motifAdjustment.xOffsetRelDelta;
    var yOffsetRel = rule.coupling.yOffsetRel + motifAdjustment.yOffsetRelDelta;
    this.scaleMotifToWidth(motifWidthRel * this.logicalWidth * rule.group.zoom);

    var motifWidth = this.motifObject.getScaledWidth();
    var textWidth = firstTextObject.getScaledWidth();
    var gapPixels = gapRel * this.logicalWidth * rule.group.zoom;
    var groupWidth = Math.max(1, motifWidth + gapPixels + textWidth);
    var groupLeft = groupX - (groupWidth / 2);
    var motifPoint = rotatePointAround(
      groupLeft + (motifWidth / 2) + (xOffsetRel * this.logicalWidth * rule.group.zoom),
      groupY + (yOffsetRel * this.logicalHeight * rule.group.zoom),
      groupX,
      groupY,
      groupAngle
    );
    var textPoint = rotatePointAround(
      groupLeft + motifWidth + gapPixels + (textWidth / 2),
      groupY,
      groupX,
      groupY,
      groupAngle
    );
    textPoint.x += firstBasePoint.x - groupX;
    textPoint.y += firstBasePoint.y - groupY;

    this.motifObject.set({
      left: motifPoint.x,
      top: motifPoint.y,
      angle: numberOr(rule.coupling.angle, 0) + motifAdjustment.angleDelta + groupAngle
    });
    firstTextObject.set({ left: textPoint.x, top: textPoint.y, angle: numberOr(firstRule.angle, 0) + groupAngle });
    this.motifObject.setCoords();
    firstTextObject.setCoords();
    activeObjects.push(this.motifObject, firstTextObject);
    this.clampObjectsToCanvasAsGroup(activeObjects);
  };

  FantastickConfigurator.prototype.applyLayout = function (shouldRender) {
    if (!this.canvas || !this.textFields.length) return;
    var rule = this.resolveLayout();
    var motifAdjustment = this.getMotifAdjustment();

    this.applyBackgroundLayout();
    rule.textRules.forEach(function (textRule) {
      this.fitText(textRule, rule.group.zoom);
    }, this);

    if (this.state.alignKey === "right") {
      this.applyRightLayout(rule, motifAdjustment);
    } else {
      this.applyCenterLayout(rule, motifAdjustment);
    }

    if (this.backgroundImage) this.canvas.sendToBack(this.backgroundImage);
    this.canvas.sendToBack(this.backgroundFill);
    if (this.motifObject) this.canvas.bringToFront(this.motifObject);
    this.textFields.forEach(function (field) {
      this.canvas.bringToFront(this.textObjects[field.key]);
    }, this);
    this.updatePreviewDescription();

    if (shouldRender !== false) this.canvas.requestRenderAll();
  };

  FantastickConfigurator.prototype.queueLayout = function () {
    if (this.layoutFrame) window.cancelAnimationFrame(this.layoutFrame);
    this.layoutFrame = window.requestAnimationFrame(function () {
      this.layoutFrame = 0;
      this.applyLayout();
    }.bind(this));
  };

  FantastickConfigurator.prototype.updatePreviewDescription = function () {
    var size = this.getSize();
    var fabric = this.getFabric();
    var motif = this.getMotif();
    var position = this.state.alignKey === "right" ? "Rechts" : "Mittig";
    var summaryParts = [];
    var fit = this.getFit();
    if (fit) summaryParts.push(fit.label);
    if (size) summaryParts.push(size.label);
    summaryParts.push(fabric.label);
    var texts = this.textFields.map(function (field) {
      return String(this.state.textValues[field.key] || "").trim();
    }, this).filter(Boolean);

    if (this.positionSelectorEnabled) summaryParts.push(position);
    if (this.motifEnabled) summaryParts.push(motif.label);

    this.elements.canvasElement.setAttribute(
      "aria-label",
      "Vorschau " + (this.config.productTitle || "personalisiertes Produkt") + ": "
        + summaryParts.join(", ") + ", " + (texts.length ? texts.join(", ") : "noch ohne Wunschtext")
    );
  };

  FantastickConfigurator.prototype.updateVariantNote = function () {
    if (!this.elements.variantNote) return;
    var size = this.getSize();
    var fabric = this.getFabric();
    var variant = this.getSelectedVariant();
    var fit = this.getFit();
    var selectionLabel = (fit ? fit.label + " · " : "") + (size ? size.label + " · " : "") + fabric.label;

    this.elements.variantNote.classList.remove("is-error", "is-warning", "is-success");
    if (!variant) {
      this.elements.variantNote.textContent = "Vorschau aktiv. Für „" + selectionLabel + "“ fehlt aber eine passende Shopify-Variante; der Warenkorb bleibt gesperrt.";
      this.elements.variantNote.classList.add("is-error");
      return;
    }

    if (!variant.available) {
      this.elements.variantNote.textContent = selectionLabel + " kann angesehen werden, ist derzeit aber ausverkauft.";
      this.elements.variantNote.classList.add("is-warning");
      return;
    }

    if (!this.hasConfiguredMockup(fabric, size)) {
      this.elements.variantNote.textContent = this.config.designMode
        ? "Für diese Passform und Farbe fehlt ein Mockup. Bitte im zugehörigen Farbblock ein Bild auswählen."
        : "Diese Auswahl ist noch nicht verfügbar. Bitte wähle eine andere Kombination.";
      this.elements.variantNote.classList.add("is-warning");
      return;
    }
    this.elements.variantNote.textContent = (size || fit ? "Ausgewählt: " + selectionLabel : "Ausgewählte Stofffarbe: " + fabric.label);
    this.elements.variantNote.classList.add("is-success");
  };

  FantastickConfigurator.prototype.updatePurchaseAvailability = function () {
    var variant = this.getSelectedVariant();
    this.elements.addButton.disabled = this.busy || !variant || !variant.available
      || !this.hasConfiguredMockup(this.getFabric(), this.getSize());
  };

  FantastickConfigurator.prototype.updateControlStates = function () {
    this.renderFitButtons();
    if (this.sizeEnabled && this.elements.sizeBar) {
      this.renderSizeButtons();
      this.elements.sizeBar.querySelectorAll("[data-size-key]").forEach(function (button) {
        var active = button.dataset.sizeKey === this.state.sizeKey;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      }, this);
    }

    this.elements.fabricBar.querySelectorAll("[data-fabric-key]").forEach(function (button) {
      var active = button.dataset.fabricKey === this.state.fabricKey;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    }, this);

    if (this.motifEnabled) {
      this.elements.motifTrack.querySelectorAll("[data-motif-key]").forEach(function (button) {
        var active = button.dataset.motifKey === this.state.motifKey;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      }, this);
    }

    var centerActive = this.state.alignKey === "center";
    this.elements.alignCenter.classList.toggle("is-active", centerActive);
    this.elements.alignCenter.setAttribute("aria-pressed", String(centerActive));
    this.elements.alignRight.classList.toggle("is-active", !centerActive);
    this.elements.alignRight.setAttribute("aria-pressed", String(!centerActive));
    this.elements.colorSelects.forEach(function (select) {
      select.value = this.state.colorKeys[select.dataset.fkcTextKey];
    }, this);
    this.elements.fontSelects.forEach(function (select) {
      select.value = this.state.fontKeys[select.dataset.fkcTextKey];
    }, this);
    if (this.elements.selectedPrice) {
      var selectedVariant = this.getSelectedVariant();
      if (!selectedVariant) {
        this.elements.selectedPrice.textContent = "Preis nicht verfügbar";
      } else if (
        selectedVariant.compareAtPrice
        && Number(selectedVariant.compareAtPrice) > Number(selectedVariant.price)
      ) {
        this.elements.selectedPrice.textContent = "Preis: " + selectedVariant.priceFormatted
          + " statt " + selectedVariant.compareAtPriceFormatted;
      } else {
        this.elements.selectedPrice.textContent = "Preis: " + selectedVariant.priceFormatted;
      }
    }
    this.updateVariantNote();
    this.updatePurchaseAvailability();
    this.updatePreviewDescription();
  };

  FantastickConfigurator.prototype.setStatus = function (message, type) {
    this.elements.status.textContent = message || "";
    this.elements.status.classList.remove("is-error", "is-success", "is-warning");
    if (type) this.elements.status.classList.add("is-" + type);
  };

  FantastickConfigurator.prototype.setBusy = function (isBusy) {
    this.busy = Boolean(isBusy);
    this.elements.addButton.setAttribute("aria-busy", String(this.busy));
    this.elements.addButton.textContent = this.busy
      ? "Vorschau wird gespeichert …"
      : (this.config.addButtonLabel || "Konfiguration in den Warenkorb");
    if (this.busy) {
      this.busyControls = Array.from(this.elements.form.querySelectorAll("input, select, textarea, button"))
        .filter(function (node) { return node !== this.elements.addButton; }, this)
        .map(function (node) { var state = [node, node.disabled]; node.disabled = true; return state; });
    } else {
      (this.busyControls || []).forEach(function (state) { state[0].disabled = state[1]; });
      this.busyControls = [];
      this.renderFabricButtons();
      this.updateControlStates();
    }
    this.updatePurchaseAvailability();
  };

  FantastickConfigurator.prototype.setPreviewCollapsed = function (isCollapsed, persist) {
    var requestedState = Boolean(isCollapsed);
    var collapsed = requestedState && this.mobileStickyPreviewEnabled();
    this.state.previewCollapsed = requestedState;
    this.root.classList.toggle("is-preview-collapsed", collapsed);

    if (this.elements.previewToggle) {
      this.elements.previewToggle.setAttribute("aria-expanded", String(!collapsed));
      this.elements.previewToggle.setAttribute(
        "aria-label",
        collapsed ? "Live-Vorschau maximieren" : "Live-Vorschau minimieren"
      );
      this.elements.previewToggle.title = collapsed ? "Live-Vorschau maximieren" : "Live-Vorschau minimieren";
    }

    if (this.elements.previewContent) {
      this.elements.previewContent.setAttribute("aria-hidden", String(collapsed));
      if ("inert" in this.elements.previewContent) this.elements.previewContent.inert = collapsed;
    }

    if (persist !== false) this.saveState();
    if (!collapsed && this.canvas) {
      window.requestAnimationFrame(function () {
        this.canvas.calcOffset();
        this.canvas.requestRenderAll();
      }.bind(this));
    }
  };

  FantastickConfigurator.prototype.togglePreview = function () {
    this.setPreviewCollapsed(!this.state.previewCollapsed);
  };

  FantastickConfigurator.prototype.mobileStickyPreviewEnabled = function () {
    return Boolean(
      this.elements.previewColumn
      && this.root.classList.contains("fkc--mobile-sticky")
      && !this.root.classList.contains("fkc--design-mode")
      && this.mobilePreviewMedia.matches
    );
  };

  // V7.4: unabhängiger Ansichts-Zoom; keine Schreibzugriffe auf layoutOverrides,
  // state, Kalibrierungspakete, Varianten oder Warenkorb-Eigenschaften.
  FantastickConfigurator.prototype.lockPreviewScroll = function () {
    if (this.previewScrollLock) return;
    var html = document.documentElement;
    this.previewScrollLock = {
      x: window.scrollX, y: window.scrollY,
      hadClass: html.classList.contains("fkc-zoom-open"),
      top: html.style.getPropertyValue("--fkc-zoom-scroll-top")
    };
    html.style.setProperty("--fkc-zoom-scroll-top", -window.scrollY + "px");
    html.classList.add("fkc-zoom-open");
  };

  FantastickConfigurator.prototype.unlockPreviewScroll = function () {
    var saved = this.previewScrollLock;
    if (!saved) return;
    this.previewScrollLock = null;
    var html = document.documentElement;
    if (!saved.hadClass) html.classList.remove("fkc-zoom-open");
    if (saved.top) html.style.setProperty("--fkc-zoom-scroll-top", saved.top);
    else html.style.removeProperty("--fkc-zoom-scroll-top");
    window.scrollTo({ left: saved.x, top: saved.y, behavior: "instant" });
  };

  FantastickConfigurator.prototype.updatePreviewDialogZoom = function (scale, reset) {
    var el = this.elements;
    if (!el.zoomDialog || !el.zoomDialog.open || !el.zoomViewport || !el.zoomImage) return;
    this.previewDialogScale = clamp(numberOr(scale, 1), 1, 3);
    var view = el.zoomViewport;
    var centerX = (view.scrollLeft + view.clientWidth / 2) / Math.max(1, view.scrollWidth);
    var centerY = (view.scrollTop + view.clientHeight / 2) / Math.max(1, view.scrollHeight);
    // Feste Exportauflösung; nur die CSS-Bildgröße ändern, niemals das Canvas.
    var fitted = Math.min(view.clientWidth / this.logicalWidth, view.clientHeight / this.logicalHeight);
    var width = Math.max(1, Math.floor(this.logicalWidth * fitted * this.previewDialogScale));
    var height = Math.max(1, Math.floor(this.logicalHeight * fitted * this.previewDialogScale));
    el.zoomImage.style.width = width + "px";
    el.zoomImage.style.height = height + "px";
    el.zoomStage.style.width = Math.max(view.clientWidth, width) + "px";
    el.zoomStage.style.height = Math.max(view.clientHeight, height) + "px";
    view.scrollLeft = reset ? (view.scrollWidth - view.clientWidth) / 2 : centerX * view.scrollWidth - view.clientWidth / 2;
    view.scrollTop = reset ? (view.scrollHeight - view.clientHeight) / 2 : centerY * view.scrollHeight - view.clientHeight / 2;
    var ready = Boolean(this.previewDialogUrl);
    if (el.zoomIn) el.zoomIn.disabled = !ready || this.previewDialogScale >= 3;
    if (el.zoomOut) el.zoomOut.disabled = !ready || this.previewDialogScale <= 1;
    if (el.zoomFit) el.zoomFit.disabled = !ready;
    if (el.zoomLevel) el.zoomLevel.textContent = Math.round(this.previewDialogScale * 100) + " %";
  };

  FantastickConfigurator.prototype.openPreviewDialog = async function (event) {
    var el = this.elements;
    var dialog = el.zoomDialog;
    if (!dialog || dialog.open || !this.canvas || this.root.dataset.fkcReady !== "true") return;
    this.syncHeaderDrawerState();
    if (this.root.classList.contains("is-site-drawer-open")) return;
    if (typeof dialog.showModal !== "function") {
      this.setStatus("Für die große Vorschau bitte einen aktuellen Browser verwenden.", "warning");
      return;
    }
    if (this.busy) return;
    if (window.__fantastickTourOwner) window.__fantastickTourOwner.close(false);
    // Mehrere Sektionen dürfen keine konkurrierenden Scroll-Sperren erzeugen.
    if (window.__fantastickPreviewOwner && window.__fantastickPreviewOwner !== this) {
      window.__fantastickPreviewOwner.closePreviewDialog(false);
    }
    window.__fantastickPreviewOwner = this;
    var token = ++this.previewDialogToken;
    this.previewDialogOpener = event && event.currentTarget instanceof HTMLElement
      ? event.currentTarget : (el.previewZoom || document.activeElement);
    if (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
      document.activeElement.blur();
    }
    this.setTextEntryMode(false);
    this.previewDialogScale = 1;
    el.zoomStatus.textContent = "Vorschau wird vorbereitet …";
    el.zoomStatus.classList.remove("is-error");
    el.zoomImage.hidden = true;
    el.zoomSave.removeAttribute("href");
    el.zoomSave.setAttribute("aria-disabled", "true");
    el.zoomSave.tabIndex = -1;
    var timeout = null;
    try {
      this.lockPreviewScroll();
      dialog.showModal();
      this.updatePreviewDialogZoom(1, true);
      var backgroundToken = this.backgroundToken;
      var motifToken = this.motifToken;
      var motif = this.getMotif();
      // Laufende Bildladevorgänge abwarten, bevor ein Snapshot erzeugt wird.
      // Dieselben Bild-Promises werden vom normalen Canvas verwendet.
      var prepare = Promise.all([
        this.ensureFontsLoaded(),
        this.loadImageElement(this.getSelectedMockupUrl()),
        this.loadImageElement(motif && motif.imageUrl)
      ]);
      await Promise.race([
        prepare,
        new Promise(function (_, reject) {
          timeout = window.setTimeout(function () {
            reject(new Error("Das Laden dauert zu lange. Bitte schließe die Vorschau und versuche es erneut."));
          }, 15000);
        })
      ]);
      if (token !== this.previewDialogToken || !dialog.open) return;
      if (backgroundToken !== this.backgroundToken || motifToken !== this.motifToken) {
        throw new Error("Die Auswahl wurde geändert. Bitte öffne die Vorschau erneut.");
      }
      var blob = await this.exportPreviewBlob();
      if (token !== this.previewDialogToken || !dialog.open) return;
      this.previewDialogUrl = URL.createObjectURL(blob);
      el.zoomImage.src = this.previewDialogUrl;
      el.zoomImage.hidden = false;
      el.zoomSave.href = this.previewDialogUrl;
      // Absichtlich ohne eingegebenen Namen und ohne kryptische IDs.
      el.zoomSave.download = "fantastick-vorschau.jpg";
      el.zoomSave.removeAttribute("aria-disabled");
      el.zoomSave.tabIndex = 0;
      el.zoomStatus.textContent = "";
      this.updatePreviewDialogZoom(1, true);
    } catch (error) {
      if (token !== this.previewDialogToken) return;
      if (!dialog.open) {
        this.closePreviewDialog();
        this.setStatus("Die große Vorschau konnte nicht geöffnet werden.", "warning");
        return;
      }
      el.zoomStatus.textContent = error.message || "Die Vorschau konnte nicht geladen werden. Bitte erneut öffnen.";
      el.zoomStatus.classList.add("is-error");
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  };

  FantastickConfigurator.prototype.closePreviewDialog = function (restoreFocus) {
    var el = this.elements;
    ++this.previewDialogToken; // verwirft auch einen noch laufenden Export
    if (el.zoomDialog && el.zoomDialog.open) el.zoomDialog.close();
    this.unlockPreviewScroll();
    if (this.previewDialogUrl) URL.revokeObjectURL(this.previewDialogUrl);
    this.previewDialogUrl = "";
    if (el.zoomImage) { el.zoomImage.hidden = true; el.zoomImage.removeAttribute("src"); }
    if (el.zoomSave) {
      el.zoomSave.removeAttribute("href");
      el.zoomSave.setAttribute("aria-disabled", "true");
      el.zoomSave.tabIndex = -1;
    }
    if (window.__fantastickPreviewOwner === this) window.__fantastickPreviewOwner = null;
    var opener = this.previewDialogOpener;
    this.previewDialogOpener = null;
    if (restoreFocus !== false && opener && opener.isConnected && !this.root.classList.contains("is-site-drawer-open")) {
      opener.focus({ preventScroll: true });
    }
  };

  // V7.7: gestures belong to the exported preview, never to the production canvas.
  FantastickConfigurator.prototype.bindPreviewGestures = function () {
    var el = this.elements;
    if (!el.zoomDialog || !el.zoomViewport) return;
    var pinch = null;
    var distance = function (touches) {
      return Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
    };
    this.listen(el.zoomDialog, "wheel", function (event) {
      if (!el.zoomDialog.open) return;
      if (!el.zoomViewport.contains(event.target)) { event.preventDefault(); return; }
      if (event.ctrlKey) {
        event.preventDefault();
        this.updatePreviewDialogZoom(this.previewDialogScale * Math.exp(-event.deltaY * 0.008));
      }
    }.bind(this), { passive: false });
    this.listen(el.zoomDialog, "touchstart", function (event) {
      if (event.touches.length === 2 && el.zoomViewport.contains(event.target)) {
        pinch = { distance: distance(event.touches), scale: this.previewDialogScale };
      } else pinch = null;
    }.bind(this), { passive: true });
    this.listen(el.zoomDialog, "touchmove", function (event) {
      if (!el.zoomDialog.open) return;
      if (!el.zoomViewport.contains(event.target)) { event.preventDefault(); return; }
      if (event.touches.length > 1) {
        event.preventDefault();
        if (pinch && pinch.distance > 0) this.updatePreviewDialogZoom(pinch.scale * distance(event.touches) / pinch.distance);
      }
    }.bind(this), { passive: false });
    this.listen(el.zoomDialog, "touchend", function () { pinch = null; }, { passive: true });
    this.listen(el.zoomDialog, "touchcancel", function () { pinch = null; }, { passive: true });
    this.listen(el.zoomDialog, "keydown", function (event) {
      if (!el.zoomDialog.open || el.zoomViewport.contains(event.target)) return;
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].indexOf(event.key) >= 0) event.preventDefault();
      if (event.key === " " && !event.target.closest("button, a")) event.preventDefault();
    });
    this.listen(el.zoomImage, "dragstart", function (event) { event.preventDefault(); });
    if (window.visualViewport) {
      this.listen(window.visualViewport, "resize", function () {
        if (el.zoomDialog.open) this.updatePreviewDialogZoom(this.previewDialogScale);
      }.bind(this), { passive: true });
    }
  };

  FantastickConfigurator.prototype.bindPreviewDialog = function () {
    var el = this.elements;
    if (!el.zoomDialog) return;
    this.listen(el.previewZoom, "click", this.openPreviewDialog.bind(this));
    var imageTap = null;
    this.listen(el.canvasOpen, "pointerdown", function (event) {
      imageTap = { x: event.clientX, y: event.clientY, moved: !event.isPrimary };
    });
    this.listen(el.canvasOpen, "pointermove", function (event) {
      if (imageTap && Math.hypot(event.clientX - imageTap.x, event.clientY - imageTap.y) > 10) imageTap.moved = true;
    }, { passive: true });
    this.listen(el.canvasOpen, "pointercancel", function () { if (imageTap) imageTap.moved = true; });
    this.listen(el.canvasOpen, "click", function (event) {
      var dragged = event.detail !== 0 && imageTap && imageTap.moved;
      imageTap = null;
      if (!dragged) this.openPreviewDialog(event);
    }.bind(this));
    this.bindPreviewGestures();
    Array.from(el.zoomDialog.querySelectorAll("[data-fkc-zoom-close]")).forEach(function (button) {
      this.listen(button, "click", function () { this.closePreviewDialog(); }.bind(this));
    }, this);
    var startedOutside = false;
    this.listen(el.zoomDialog, "pointerdown", function (event) { startedOutside = event.target === el.zoomDialog; });
    this.listen(el.zoomDialog, "click", function (event) {
      if (startedOutside && event.target === el.zoomDialog) this.closePreviewDialog();
      startedOutside = false;
    }.bind(this));
    this.listen(el.zoomDialog, "cancel", function (event) {
      event.preventDefault();
      this.closePreviewDialog();
    }.bind(this));
    this.listen(el.zoomDialog, "close", function () {
      // Ein altes close-Ereignis darf einen inzwischen neu geöffneten Dialog nicht löschen.
      if (!el.zoomDialog.open) this.closePreviewDialog();
    }.bind(this));
    this.listen(el.zoomIn, "click", function () { this.updatePreviewDialogZoom(this.previewDialogScale + 0.5); }.bind(this));
    this.listen(el.zoomOut, "click", function () { this.updatePreviewDialogZoom(this.previewDialogScale - 0.5); }.bind(this));
    this.listen(el.zoomFit, "click", function () { this.updatePreviewDialogZoom(1, true); }.bind(this));
    this.listen(el.zoomSave, "click", function (event) {
      if (!this.previewDialogUrl) event.preventDefault();
    }.bind(this));
    if (window.ResizeObserver && el.zoomViewport) {
      this.previewDialogObserver = new ResizeObserver(function () {
        if (el.zoomDialog.open) this.updatePreviewDialogZoom(this.previewDialogScale);
      }.bind(this));
      this.previewDialogObserver.observe(el.zoomViewport);
    }
  };

  FantastickConfigurator.prototype.syncHeaderDrawerState = function () {
    var drawer = document.querySelector("#Details-menu-drawer-container, header-drawer > details[scroll-lock]");
    var isOpen = Boolean(drawer && drawer.hasAttribute("open"));
    this.root.classList.toggle("is-site-drawer-open", isOpen);
    if (isOpen && this.elements.zoomDialog && this.elements.zoomDialog.open) this.closePreviewDialog(false);
    if (isOpen && this.tour) this.tour.close(false);
  };

  FantastickConfigurator.prototype.observeHeaderDrawer = function () {
    var drawer = document.querySelector("#Details-menu-drawer-container, header-drawer > details[scroll-lock]");
    this.syncHeaderDrawerState();
    if (!drawer) return;

    this.listen(drawer, "toggle", this.syncHeaderDrawerState.bind(this));

    if (window.MutationObserver) {
      this.headerDrawerObserver = new MutationObserver(this.syncHeaderDrawerState.bind(this));
      this.headerDrawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ["open"]
      });
    }
  };

  FantastickConfigurator.prototype.setTextEntryMode = function (isActive, input) {
    window.clearTimeout(this.textEntryTimer);
    var shouldCompact = Boolean(isActive) && this.mobileStickyPreviewEnabled();
    this.activeTextInput = shouldCompact ? input : null;
    this.root.classList.toggle("is-text-entry", shouldCompact);
    if (!shouldCompact) return;

    this.textEntryTimer = window.setTimeout(function () {
      if (!this.activeTextInput || document.activeElement !== this.activeTextInput) return;
      this.activeTextInput.scrollIntoView({ behavior: "auto", block: "center", inline: "nearest" });
    }.bind(this), 260);
  };

  FantastickConfigurator.prototype.activateSize = async function (sizeKey) {
    if (this.busy || !this.sizeEnabled) return;
    var size = this.sizes.find(function (item) { return item.key === sizeKey; });
    if (!size || this.state.sizeKey === sizeKey) return;
    var availableFabrics = this.availableFabricsForSize(size);
    if (!availableFabrics.length && !this.config.designMode) return;
    var previousMockup = this.getSelectedMockupUrl();
    this.state.sizeKey = sizeKey;
    var variant = this.getSelectedVariant();
    var message = "";
    if ((!variant || !variant.available || !this.hasConfiguredMockup(this.getFabric(), size)) && availableFabrics.length && !this.config.designMode) {
      this.state.fabricKey = availableFabrics[0].key;
      message = "Größe " + size.label + " ist in der bisherigen Farbe nicht verfügbar. Wir haben "
        + availableFabrics[0].label + " ausgewählt. Du kannst unten eine andere verfügbare Farbe wählen.";
    }
    this.saveState();
    this.setStatus("");
    this.renderFabricButtons();
    this.updateControlStates();
    if (message) {
      this.elements.variantNote.textContent = message;
      this.elements.variantNote.classList.remove("is-success");
      this.elements.variantNote.classList.add("is-warning");
    }
    this.renderCalibrationControls();
    if (this.sizeSpecificLayouts || previousMockup !== this.getSelectedMockupUrl()) await this.loadSelectedBackground();
    else this.queueLayout();
  };

  FantastickConfigurator.prototype.activateFabric = async function (fabricKey) {
    var fabricOption = this.fabrics.find(function (item) { return item.key === fabricKey; });
    if (this.busy || !fabricOption || this.state.fabricKey === fabricKey) return;
    if (this.fitEnabled && (fabricOption.fitKey || "herren") !== this.state.fitKey) {
      if (!this.config.designMode) return;
      var fitKey = fabricOption.fitKey || "herren";
      if (!this.fits.some(function (fit) { return fit.key === fitKey; })) return;
      await this.activateFit(fitKey);
    }
    var variant = this.variantForFabric(fabricOption);
    if ((!variant || !variant.available || !this.hasConfiguredMockup(fabricOption, this.getSize())) && !this.config.designMode) return;

    this.state.fabricKey = fabricKey;
    this.saveState();
    this.setStatus("");
    this.updateControlStates();
    this.renderCalibrationControls();
    await this.loadSelectedBackground();
  };

  FantastickConfigurator.prototype.activateMotif = async function (motifKey) {
    var motif = this.motifs.find(function (item) { return item.key === motifKey; });
    if (!motif || (motif.key !== "none" && !motif.imageUrl) || this.state.motifKey === motifKey) return;

    this.state.motifKey = motifKey;
    this.saveState();
    this.setStatus("");
    this.updateControlStates();
    await this.loadSelectedMotif();
  };

  FantastickConfigurator.prototype.setAlignment = function (alignKey) {
    if (!this.positionSelectorEnabled) return;
    this.state.alignKey = alignKey === "right" ? "right" : "center";
    this.saveState();
    this.setStatus("");
    this.updateControlStates();
    this.renderCalibrationControls();
    this.queueLayout();
  };

  FantastickConfigurator.prototype.exportCalibrationBundle = function () {
    var bundle = {
      format: "fantastick-calibration",
      version: "7.0",
      productKey: String(this.config.productKey || ""),
      canvas: {
        ratio: String(this.config.canvasRatio || ""),
        width: this.logicalWidth,
        height: this.logicalHeight
      }
    };

    var exportValues = function (layout) {
      var center = clone(layout.center);
      var right = clone(layout.right);
      center.texts = {};
      right.texts = {};
      this.textFields.forEach(function (field) {
        center.texts[field.key] = clone(layout.center && layout.center.texts && layout.center.texts[field.key]);
        right.texts[field.key] = clone(layout.right && layout.right.texts && layout.right.texts[field.key]);
      });
      return { background: clone(layout.background), center: center, right: right };
    }.bind(this);

    if (this.sizeSpecificLayouts) {
      bundle.sizes = {};
      this.layoutOverrides.forEach(function (layout) {
        var sizeKey = layout.sizeCalibrationKey || layout.sizeKey;
        var fabricKey = layout.calibrationKey || layout.fabricKey;
        if (!bundle.sizes[sizeKey]) bundle.sizes[sizeKey] = {};
        bundle.sizes[sizeKey][fabricKey] = exportValues(layout);
      });
      return bundle;
    }

    bundle.layouts = {};
    this.layoutOverrides.forEach(function (layout) {
      var key = layout.calibrationKey || layout.fabricKey;
      bundle.layouts[key] = exportValues(layout);
    });
    return bundle;
  };

  FantastickConfigurator.prototype.updateCalibrationOutput = function () {
    if (!this.elements.calibrationOutput) return;
    this.elements.calibrationOutput.value = encodePortableJson(this.exportCalibrationBundle());
  };

  FantastickConfigurator.prototype.setCalibrationStatus = function (message, type) {
    if (!this.elements.calibrationStatus) return;
    this.elements.calibrationStatus.textContent = message || "";
    this.elements.calibrationStatus.classList.remove("is-error", "is-success", "is-warning");
    if (type) this.elements.calibrationStatus.classList.add("is-" + type);
  };

  FantastickConfigurator.prototype.buildCalibrationFields = function () {
    var alignment = this.state.alignKey;
    var fields = clone(CALIBRATION_BACKGROUND_FIELDS);

    CALIBRATION_GROUP_FIELDS.forEach(function (definition) {
      fields.push(Object.assign({}, definition, { path: alignment + "." + definition.name }));
    });

    this.textFields.forEach(function (field, index) {
      var prefix = this.textFields.length > 1
        ? "Text " + (index + 1) + " („" + field.heading + "“): "
        : "Text: ";
      var defaults = textDefaults(field, alignment, index);
      [
        { name: "x", label: "horizontal", min: 0, max: 100, step: 0.5, unit: "%" },
        { name: "y", label: "vertikal", min: 0, max: 100, step: 0.5, unit: "%" },
        { name: "size", label: "Größe", min: 2, max: 20, step: 0.25, unit: "%" },
        { name: "rotation", label: "Drehung", min: -180, max: 180, step: 1, unit: "°" },
        { name: "width", label: "maximale Breite", min: 10, max: 100, step: 0.5, unit: "%" }
      ].forEach(function (definition) {
        fields.push({
          path: alignment + ".texts." + field.key + "." + definition.name,
          label: prefix + definition.label,
          min: definition.min,
          max: definition.max,
          step: definition.step,
          unit: definition.unit,
          fallback: defaults[definition.name]
        });
      });
    }, this);

    if (this.motifEnabled) {
      var motifFallbacks = alignment === "right"
        ? { motifSize: 20, motifGap: 0, motifX: 0, motifY: 0, motifRotation: 0 }
        : { motifSize: 23, motifGap: 2, motifX: 0, motifY: 5, motifRotation: 0 };
      CALIBRATION_MOTIF_FIELDS.forEach(function (definition) {
        fields.push(Object.assign({}, definition, {
          path: alignment + "." + definition.name,
          fallback: motifFallbacks[definition.name]
        }));
      });
    }

    return fields;
  };

  FantastickConfigurator.prototype.renderCalibrationControls = function () {
    if (!this.elements.calibrationControls) return;
    var calibration = this.getCalibration();
    var fabric = this.getFabric();
    var size = this.sizeSpecificLayouts ? this.getSize() : null;
    var alignmentLabel = this.state.alignKey === "right" ? "Rechts" : "Mittig";
    var fields = this.buildCalibrationFields();
    var fragment = document.createDocumentFragment();

    if (this.elements.calibrationCurrent) {
      var fit = this.getFit();
      this.elements.calibrationCurrent.textContent = (fit ? fit.label + " · " : "") + (size ? size.label + " · " : "") + fabric.label + " · " + alignmentLabel;
    }

    fields.forEach(function (definition, index) {
      var row = document.createElement("div");
      var heading = document.createElement("div");
      var label = document.createElement("label");
      var output = document.createElement("output");
      var input = document.createElement("input");
      var inputId = "FkcCalibration-" + String(this.config.sectionId || "section") + "-" + index;
      var value = numberOr(getPath(calibration, definition.path), definition.fallback);

      row.className = "fkc__calibrator-row";
      heading.className = "fkc__calibrator-row-heading";
      label.className = "fkc__calibrator-row-label";
      label.htmlFor = inputId;
      label.textContent = definition.label;
      output.className = "fkc__calibrator-value";
      output.htmlFor = inputId;
      output.textContent = value + definition.unit;

      input.id = inputId;
      input.className = "fkc__calibrator-range";
      input.type = "range";
      input.min = String(definition.min);
      input.max = String(definition.max);
      input.step = String(definition.step);
      input.value = String(value);
      input.dataset.fkcCalibrationPath = definition.path;
      input.dataset.fkcCalibrationUnit = definition.unit;

      heading.appendChild(label);
      heading.appendChild(output);
      row.appendChild(heading);
      row.appendChild(input);
      fragment.appendChild(row);
    }, this);

    this.elements.calibrationControls.replaceChildren(fragment);
    this.renderCalibrationTransferTargets();
    this.updateCalibrationOutput();
  };

  FantastickConfigurator.prototype.renderCalibrationTransferTargets = function () {
    if (!this.elements.calibrationTarget) return;
    var previousValue = this.elements.calibrationTarget.value;
    var fragment = document.createDocumentFragment();
    var targets = this.getFabricsForFit().filter(function (fabric) {
      return fabric.key !== this.state.fabricKey;
    }, this);

    targets.forEach(function (fabric) {
      var option = document.createElement("option");
      option.value = fabric.key;
      option.textContent = fabric.label;
      fragment.appendChild(option);
    });

    this.elements.calibrationTarget.replaceChildren(fragment);
    if (targets.some(function (fabric) { return fabric.key === previousValue; })) {
      this.elements.calibrationTarget.value = previousValue;
    }
    this.elements.calibrationTarget.disabled = targets.length === 0;
    if (this.elements.calibrationApplyTarget) this.elements.calibrationApplyTarget.disabled = targets.length === 0;
  };

  FantastickConfigurator.prototype.handleCalibrationInput = function (event) {
    var input = event.target.closest("[data-fkc-calibration-path]");
    if (!input) return;
    var calibration = this.getCalibration();
    var value = numberOr(input.value, 0);
    setPath(calibration, input.dataset.fkcCalibrationPath, value);

    var output = input.closest(".fkc__calibrator-row").querySelector(".fkc__calibrator-value");
    if (output) output.textContent = value + (input.dataset.fkcCalibrationUnit || "");

    this.saveCalibrationDraft();
    this.updateCalibrationOutput();
    this.setCalibrationStatus("Nur im Browser geändert – noch nicht dauerhaft in Shopify gespeichert.", "warning");
    this.queueLayout();
  };

  FantastickConfigurator.prototype.writeCalibrationCodeToClipboard = async function () {
    if (!this.elements.calibrationOutput) return false;
    this.updateCalibrationOutput();
    var text = this.elements.calibrationOutput.value;
    var copied = false;

    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      try {
        await navigator.clipboard.writeText(text);
        copied = true;
      } catch (error) {
        copied = false;
      }
    }

    if (!copied) {
      try {
        this.elements.calibrationOutput.focus();
        this.elements.calibrationOutput.select();
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }
    }

    return copied;
  };

  FantastickConfigurator.prototype.copyCalibrationScope = function (source, target, scope) {
    if (!source || !target) return false;

    if (scope === "all") {
      target.background = clone(source.background);
      target.center = clone(source.center);
      target.right = clone(source.right);
    } else if (scope === "positions") {
      target.center = clone(source.center);
      target.right = clone(source.right);
    } else {
      target[this.state.alignKey] = clone(source[this.state.alignKey]);
    }

    ensureCalibrationTextLayouts(target, this.textFields);
    return true;
  };

  FantastickConfigurator.prototype.applyCalibrationToTarget = async function () {
    if (!this.elements.calibrationTarget || !this.elements.calibrationTarget.value) return;
    var sourceFabric = this.getFabric();
    var source = this.getCalibration();
    var targetFabricKey = this.elements.calibrationTarget.value;
    var targetFabric = this.getFabricsForFit().find(function (fabric) { return fabric.key === targetFabricKey; });
    var target = this.layoutOverrides.find(function (layout) {
      return layout.fabricKey === targetFabricKey
        && (!this.sizeSpecificLayouts || layout.sizeKey === this.state.sizeKey);
    }, this);
    var scope = this.elements.calibrationScope ? this.elements.calibrationScope.value : "position";

    if (!sourceFabric || !targetFabric || !target || source.fabricKey === target.fabricKey) {
      this.setCalibrationStatus("Bitte eine andere Ziel-Stofffarbe auswählen.", "error");
      return;
    }

    this.copyCalibrationScope(source, target, scope);

    this.saveCalibrationDraft();
    this.updateCalibrationOutput();
    var copied = await this.writeCalibrationCodeToClipboard();
    this.setCalibrationStatus(
      "Kalibrierung von „" + sourceFabric.label + "“ wurde auf „" + targetFabric.label + "“"
        + (this.sizeSpecificLayouts ? " innerhalb der aktuellen Größe" : "")
        + " übertragen. "
        + (copied
          ? "Der vollständige FKC7-Code wurde kopiert. Jetzt links in „Kalibrierungs-Paket“ einfügen und oben auf Speichern klicken."
          : "Der Entwurf ist noch nicht gespeichert. FKC7-Code unten manuell kopieren, links in „Kalibrierungs-Paket“ einfügen und speichern."),
      copied ? "success" : "warning"
    );
    this.queueLayout();
  };

  FantastickConfigurator.prototype.importCalibrationBundle = function () {
    if (!this.elements.calibrationImportInput) return;
    var value = this.elements.calibrationImportInput.value.trim();
    if (!value) {
      this.setCalibrationStatus("Bitte zuerst altes JSON oder einen FKC6-/FKC7-Code in das Importfeld einfügen.", "error");
      return;
    }

    var warnings = [];
    var bundle = parseObject(value, "Das importierte Kalibrierungs-Paket", warnings);
    if (!bundle) {
      this.setCalibrationStatus(warnings.join(" ") || "Das Paket konnte nicht gelesen werden.", "error");
      return;
    }

    var appliedCount = mergeCalibrationBundle(
      this.layoutOverrides,
      bundle,
      this.config,
      this.textFields,
      warnings
    );
    if (!appliedCount) {
      this.setCalibrationStatus(
        warnings.join(" ") || "Keine passende Kombination gefunden. Prüfe die stabilen Größen- und Farbschlüssel.",
        "error"
      );
      return;
    }

    this.elements.calibrationImportInput.value = "";
    this.saveCalibrationDraft();
    this.renderCalibrationControls();
    this.setCalibrationStatus(
      appliedCount + (appliedCount === 1 ? " Kalibrierung wurde" : " Kalibrierungen wurden")
        + " importiert. Jetzt den neuen FKC7-Code kopieren und speichern.",
      warnings.length ? "warning" : "success"
    );
    this.queueLayout();
  };

  FantastickConfigurator.prototype.applyCalibrationScopeToAllFabrics = async function (scope) {
    var sourceFabric = this.getFabric();
    var source = clone(this.getCalibration());
    var affectedCount = 0;
    if (!sourceFabric.key) {
      this.setCalibrationStatus("Bitte zuerst einen Farbblock für diese Passform anlegen.", "warning");
      return;
    }
    var allowedKeys = new Set(this.getFabricsForFit().map(function (fabric) { return fabric.key; }));
    this.layoutOverrides.forEach(function (layout) {
      if (!allowedKeys.has(layout.fabricKey)) return;
      if (this.sizeSpecificLayouts && layout.sizeKey !== this.state.sizeKey) return;
      if (layout.fabricKey === source.fabricKey) return;
      if (this.copyCalibrationScope(source, layout, scope)) affectedCount += 1;
    }, this);

    if (!affectedCount) {
      this.setCalibrationStatus("Es gibt keine weitere Stofffarbe in dieser Passform bzw. Größe.", "warning");
      return;
    }

    var scopeLabel = scope === "all"
      ? "Alles inklusive Mockup sowie Mittig und Rechts"
      : scope === "positions"
        ? "Mittig und Rechts ohne Mockup"
        : (this.state.alignKey === "right" ? "Nur Rechts" : "Nur Mittig");

    this.saveCalibrationDraft();
    this.updateCalibrationOutput();
    var copied = await this.writeCalibrationCodeToClipboard();
    this.setCalibrationStatus(
      scopeLabel
        + " wurde von „" + (sourceFabric ? sourceFabric.label : "der Quellfarbe") + "“ auf "
        + affectedCount + (affectedCount === 1 ? " weitere Stofffarbe" : " weitere Stofffarben")
        + (this.sizeSpecificLayouts ? " der aktuellen Größe" : "")
        + (this.fitEnabled ? " der Passform " + this.getFit().label : "")
        + " übertragen. Nicht gewählte Bereiche blieben unverändert. "
        + (copied
          ? "Der vollständige FKC7-Code wurde kopiert. Jetzt links in „Kalibrierungs-Paket“ einfügen und oben auf Speichern klicken."
          : "Der Entwurf ist noch nicht gespeichert. FKC7-Code unten manuell kopieren, links in „Kalibrierungs-Paket“ einfügen und speichern."),
      copied ? "success" : "warning"
    );
    this.queueLayout();
  };

  FantastickConfigurator.prototype.applyCurrentPositionToAllFabrics = function () {
    return this.applyCalibrationScopeToAllFabrics("position");
  };

  FantastickConfigurator.prototype.applyAllPositionsToAllFabrics = function () {
    return this.applyCalibrationScopeToAllFabrics("positions");
  };

  FantastickConfigurator.prototype.applyCompleteCalibrationToAllFabrics = function () {
    return this.applyCalibrationScopeToAllFabrics("all");
  };

  FantastickConfigurator.prototype.resetCalibrationDraft = function () {
    this.layoutOverrides = clone(this.savedLayoutOverrides);
    this.clearCalibrationDraft();
    this.renderCalibrationControls();
    this.setCalibrationStatus("Entwurf wurde auf die zuletzt gespeicherten Werte zurückgesetzt.", "success");
    this.queueLayout();
  };

  FantastickConfigurator.prototype.copyCalibrationBundle = async function () {
    var copied = await this.writeCalibrationCodeToClipboard();

    this.setCalibrationStatus(
      copied
        ? "FKC7-Code kopiert. Jetzt links das Sektionsfeld „Kalibrierungs-Paket“ öffnen, den bisherigen Inhalt vollständig ersetzen und oben im Theme-Editor auf Speichern klicken."
        : "Automatisches Kopieren wurde blockiert. Markiere den FKC7-Code manuell, kopiere ihn und ersetze damit links den Inhalt von „Kalibrierungs-Paket“.",
      copied ? "success" : "error"
    );
  };

  FantastickConfigurator.prototype.exportPreviewBlob = async function () {
    await this.ensureFontsLoaded();
    this.applyLayout(false);
    this.canvas.renderAll();

    var exportCanvas;
    try {
      exportCanvas = this.canvas.toCanvasElement(1);
    } catch (error) {
      throw new Error("Das Vorschaubild konnte wegen eines nicht freigegebenen Bild-Assets nicht erzeugt werden.");
    }

    if (typeof exportCanvas.toBlob === "function") {
      return new Promise(function (resolve, reject) {
        try {
          exportCanvas.toBlob(function (blob) {
            if (!blob) {
              reject(new Error("Das Vorschaubild konnte nicht erzeugt werden."));
              return;
            }
            resolve(blob);
          }, "image/jpeg", 0.88);
        } catch (error) {
          reject(new Error("Das Vorschaubild konnte wegen eines nicht freigegebenen Bild-Assets nicht erzeugt werden."));
        }
      });
    }

    try {
      var response = await fetch(exportCanvas.toDataURL("image/jpeg", 0.88));
      return await response.blob();
    } catch (error) {
      throw new Error("Dieser Browser konnte das Vorschaubild nicht speichern.");
    }
  };

  FantastickConfigurator.prototype.addToCart = async function () {
    if (this.busy) return;

    var selections = this.textFields.map(function (field) {
      var input = this.getTextInput(field.key);
      return {
        field: field,
        input: input,
        text: this.normalizeText(field.key, input ? input.value : "").trim(),
        color: this.getColor(field.key),
        font: this.getFont(field.key)
      };
    }, this);
    var sizeOption = this.getSize();
    var fabricOption = this.getFabric();
    var variant = this.getSelectedVariant();
    var motif = this.getMotif();
    var fitOption = this.getFit();
    var variantSelectionLabel = fitOption ? "Passform-/Größen-/Farbkombination" : (sizeOption ? "Größen-/Farbkombination" : "Stofffarbe");
    var positionLabel = this.state.alignKey === "right" ? "Rechts" : "Mittig";
    var missingSelection = selections.find(function (selection) {
      return selection.field.required && !selection.text;
    });

    if (missingSelection) {
      this.setStatus("Bitte fülle „" + missingSelection.field.heading + "“ aus.", "error");
      missingSelection.input.focus({ preventScroll: true });
      missingSelection.input.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (!variant) {
      this.setStatus("Für diese " + variantSelectionLabel + " fehlt die passende Shopify-Variante. Prüfe Variantenwerte und Optionspositionen.", "error");
      return;
    }

    if (!variant.available) {
      this.setStatus("Die gewählte " + variantSelectionLabel + " ist derzeit ausverkauft.", "error");
      return;
    }

    if (!this.hasConfiguredMockup(fabricOption, sizeOption)) {
      this.setStatus("Für diese Auswahl ist die Vorschau noch nicht verfügbar. Bitte wähle eine andere Kombination.", "error");
      return;
    }
    this.setBusy(true);
    this.setStatus("");

    try {
      await this.refreshVariantData();
      var checkedVariant = this.getSelectedVariant();
      if (!checkedVariant || !checkedVariant.available) {
        throw new Error("Diese Auswahl ist inzwischen nicht mehr verfügbar. Bitte wähle eine andere Größe oder Farbe.");
      }
      if (Number(checkedVariant.price) !== Number(variant.price)) {
        throw new Error("Der Preis wurde auf " + checkedVariant.priceFormatted + " aktualisiert. Bitte prüfe ihn und klicke erneut auf den Warenkorb-Button.");
      }
      variant = checkedVariant;
      // Finish current image loads before taking the snapshot; controls remain locked.
      await Promise.all([this.loadSelectedBackground(), this.loadSelectedMotif()]);
      if ((this.getSelectedMockupUrl() && !this.backgroundImage) || (motif.imageUrl && !this.motifObject)) {
        throw new Error("Ein Vorschaubild konnte nicht geladen werden. Bitte erneut versuchen.");
      }
      var previewId = uniqueId();
      var previewBlob = await this.exportPreviewBlob();

      var formData = new FormData();
      formData.append("id", String(variant.id));
      formData.append("quantity", "1");
      if (fitOption) formData.append("properties[Passform]", fitOption.label);
      if (sizeOption) formData.append("properties[Größe]", sizeOption.label);
      formData.append("properties[Stofffarbe]", fabricOption.label);

      selections.forEach(function (selection, index) {
        if (!selection.text) return;
        var baseLabel = selection.field.cartLabel;
        if (selections.some(function (other, otherIndex) {
          return otherIndex < index && other.text && other.field.cartLabel === baseLabel;
        })) {
          baseLabel = safePropertyName(baseLabel + " " + (index + 1), "Text " + (index + 1));
        }
        formData.append("properties[" + baseLabel + "]", selection.text);
        formData.append(
          "properties[" + (selections.length > 1 ? baseLabel + " – Schriftart" : "Schriftart") + "]",
          selection.font.name
        );
        formData.append(
          "properties[" + (selections.length > 1 ? baseLabel + " – Garnfarbe" : "Garnfarbe") + "]",
          selection.color.name
        );
      });

      if (this.motifEnabled) formData.append("properties[Motiv]", motif.label);
      if (this.positionSelectorEnabled) formData.append("properties[Position]", positionLabel);
      formData.append(
        "properties[Vorschaubild]",
        previewBlob,
        "fantastick-" + safeFilePart(this.config.previewFilePrefix) + "-" + previewId + ".jpg"
      );

      var response = await fetch(this.config.cartAddUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        body: formData
      });

      var responseData = null;
      try {
        responseData = await response.json();
      } catch (error) {
        responseData = null;
      }

      if (!response.ok) {
        var message = responseData && (responseData.description || responseData.message);
        if (response.status === 422) {
          try { await this.refreshVariantData(); } catch (refreshError) { /* Preserve the Shopify error below. */ }
        }
        throw new Error(message || "Shopify konnte die Konfiguration nicht in den Warenkorb legen.");
      }

      this.setStatus("Konfiguration wurde hinzugefügt. Warenkorb wird geöffnet …", "success");
      window.location.assign(this.config.cartUrl || "/cart");
    } catch (error) {
      this.setBusy(false);
      this.setStatus(error.message || "Beim Hinzufügen ist ein Fehler aufgetreten.", "error");
    }
  };

  FantastickConfigurator.prototype.updateControlScrollMargins = function () {
    var preview = this.elements.previewColumn;
    var checkout = this.elements.form.querySelector(".fkc__checkout");
    if (!preview) return;
    var top = parseFloat(window.getComputedStyle(preview).top) || 0;
    this.root.style.setProperty("--fkc-control-scroll-top", Math.ceil(preview.getBoundingClientRect().height + top + 12) + "px");
    this.root.style.setProperty("--fkc-control-scroll-bottom", Math.ceil((checkout && window.getComputedStyle(checkout).position === "sticky" ? checkout.getBoundingClientRect().height : 0) + 12) + "px");
  };

  FantastickConfigurator.prototype.bindEvents = function () {
    this.listen(this.elements.fitBar, "click", function (event) {
      var button = event.target.closest("[data-fit-key]");
      if (button && !button.disabled) this.activateFit(button.dataset.fitKey);
    }.bind(this));
    this.listen(this.elements.sizeBar, "click", function (event) {
      var button = event.target.closest("[data-size-key]");
      if (button) this.activateSize(button.dataset.sizeKey);
    }.bind(this));

    this.listen(this.elements.fabricBar, "click", function (event) {
      var button = event.target.closest("[data-fabric-key]");
      if (button) this.activateFabric(button.dataset.fabricKey);
    }.bind(this));

    this.listen(this.elements.previewToggle, "click", this.togglePreview.bind(this));
    this.bindPreviewDialog();
    this.observeHeaderDrawer();

    this.listen(this.elements.motifTrack, "click", function (event) {
      var button = event.target.closest("[data-motif-key]");
      if (button && !button.disabled) this.activateMotif(button.dataset.motifKey);
    }.bind(this));

    this.listen(this.elements.alignCenter, "click", function () { this.setAlignment("center"); }.bind(this));
    this.listen(this.elements.alignRight, "click", function () { this.setAlignment("right"); }.bind(this));

    this.elements.textInputs.forEach(function (input) {
      this.listen(input, "input", function () {
        this.normalizeText(input.dataset.fkcTextKey, input.value);
        this.saveState();
        this.setStatus("");
        this.queueLayout();
      }.bind(this));

      this.listen(input, "focus", function () {
        this.setTextEntryMode(true, input);
      }.bind(this));

      this.listen(input, "blur", function () {
        this.setTextEntryMode(false, input);
      }.bind(this));
    }, this);

    this.elements.colorSelects.forEach(function (select) {
      this.listen(select, "change", function () {
        this.state.colorKeys[select.dataset.fkcTextKey] = select.value;
        this.saveState();
        this.setStatus("");
        this.queueLayout();
      }.bind(this));
    }, this);

    this.elements.fontSelects.forEach(function (select) {
      this.listen(select, "change", async function () {
        var fieldKey = select.dataset.fkcTextKey;
        this.state.fontKeys[fieldKey] = select.value;
        this.saveState();
        this.setStatus("");
        await this.ensureFontLoaded(fieldKey);
        this.queueLayout();
      }.bind(this));
    }, this);

    this.listen(this.elements.form, "submit", function (event) {
      event.preventDefault();
      this.addToCart();
    }.bind(this));

    this.listen(this.elements.calibrationControls, "input", this.handleCalibrationInput.bind(this));
    this.listen(this.elements.calibrationCopy, "click", this.copyCalibrationBundle.bind(this));
    this.listen(this.elements.calibrationApplyAll, "click", this.applyCurrentPositionToAllFabrics.bind(this));
    this.listen(this.elements.calibrationApplyPositionsAll, "click", this.applyAllPositionsToAllFabrics.bind(this));
    this.listen(this.elements.calibrationApplyCompleteAll, "click", this.applyCompleteCalibrationToAllFabrics.bind(this));
    this.listen(this.elements.calibrationApplyTarget, "click", this.applyCalibrationToTarget.bind(this));
    this.listen(this.elements.calibrationImport, "click", this.importCalibrationBundle.bind(this));
    this.listen(this.elements.calibrationReset, "click", this.resetCalibrationDraft.bind(this));

    if (this.mobilePreviewMedia && typeof this.mobilePreviewMedia.addEventListener === "function") {
      this.listen(this.mobilePreviewMedia, "change", function () {
        this.setPreviewCollapsed(this.state.previewCollapsed, false);
      }.bind(this));
    }

    this.listen(window, "orientationchange", function () {
      window.setTimeout(function () {
        if (this.canvas) {
          this.canvas.calcOffset();
          this.canvas.requestRenderAll();
        }
      }.bind(this), 120);
    }.bind(this), { passive: true });

    this.listen(window, "pageshow", function () {
      if (this.canvas) this.canvas.requestRenderAll();
    }.bind(this));

    this.listen(document, "visibilitychange", function () {
      if (!document.hidden && this.canvas) this.canvas.requestRenderAll();
    }.bind(this));

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(function () {
        if (!this.canvas) return;
        this.canvas.calcOffset();
        this.canvas.requestRenderAll();
        this.updateControlScrollMargins();
      }.bind(this));
      this.resizeObserver.observe(this.elements.canvasWrap);
      if (this.elements.previewColumn) this.resizeObserver.observe(this.elements.previewColumn);
      var checkout = this.elements.form.querySelector(".fkc__checkout");
      if (checkout) this.resizeObserver.observe(checkout);
    }
  };

  FantastickConfigurator.prototype.init = async function () {
    this.requireSetup();
    this.chooseInitialState();
    this.setupCanvas();
    this.renderFabricButtons();
    this.renderMotifButtons();
    this.renderSelects();
    this.textFields.forEach(function (field) {
      var input = this.getTextInput(field.key);
      if (input) input.value = this.state.textValues[field.key] || "";
      this.normalizeText(field.key, this.state.textValues[field.key]);
    }, this);
    this.bindEvents();
    this.setPreviewCollapsed(this.state.previewCollapsed, false);
    this.updateControlStates();
    this.renderCalibrationControls();
    this.setCanvasLoading(true, "Vorschau wird vorbereitet …");

    if (this.warnings.length) this.setCalibrationStatus(this.warnings.join(" "), "warning");

    await Promise.all([
      this.ensureFontsLoaded(),
      this.loadSelectedBackground(),
      this.loadSelectedMotif()
    ]);

    this.applyLayout();
    this.setCanvasLoading(false);
    this.updateControlScrollMargins();
    this.root.dataset.fkcReady = "true";
    if (this.elements.previewZoom) this.elements.previewZoom.disabled = false;
    if (this.elements.canvasOpen) this.elements.canvasOpen.disabled = false;
    if (window.FantastickConfiguratorTour) window.FantastickConfiguratorTour.attach(this);
  };

  FantastickConfigurator.prototype.destroy = function () {
    if (this.tour) { this.tour.destroy(); this.tour = null; }
    if (this.elements.canvasOpen) this.elements.canvasOpen.disabled = true;
    this.closePreviewDialog(false);
    if (this.previewDialogObserver) this.previewDialogObserver.disconnect();
    if (this.elements.previewZoom) this.elements.previewZoom.disabled = true;
    this.saveState();
    this.listeners.forEach(function (removeListener) { removeListener(); });
    this.listeners = [];
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.headerDrawerObserver) this.headerDrawerObserver.disconnect();
    if (this.layoutFrame) window.cancelAnimationFrame(this.layoutFrame);
    window.clearTimeout(this.textEntryTimer);
    this.backgroundToken += 1;
    this.motifToken += 1;
    if (this.canvas) this.canvas.dispose();
    this.root.classList.remove("is-text-entry", "is-preview-collapsed", "is-site-drawer-open");
    if (this.elements.previewContent && "inert" in this.elements.previewContent) {
      this.elements.previewContent.inert = false;
    }
    this.root.dataset.fkcInitialized = "false";
    this.root.dataset.fkcReady = "false";
  };

  function initRoot(root) {
    if (!root || root.dataset.fkcInitialized === "true") return;
    root.dataset.fkcInitialized = "true";

    var instance;
    try {
      instance = new FantastickConfigurator(root, parseConfig(root));
      root._fkcInstance = instance;
      instance.init().catch(function (error) {
        if (instance.elements.addButton) instance.elements.addButton.disabled = true;
        instance.setCanvasLoading(false);
        instance.setStatus(error.message || "Der Konfigurator konnte nicht gestartet werden.", "error");
        root.dataset.fkcInitialized = "error";
      });
    } catch (error) {
      var status = root.querySelector("[data-fkc-status]");
      if (status) {
        status.textContent = error.message || "Der Konfigurator konnte nicht gestartet werden.";
        status.classList.add("is-error");
      }
      root.dataset.fkcInitialized = "error";
    }
  }

  function rootsInside(scope) {
    var roots = [];
    if (directRootMatches(scope)) roots.push(scope);
    if (scope && typeof scope.querySelectorAll === "function") {
      scope.querySelectorAll(ROOT_SELECTOR).forEach(function (root) { roots.push(root); });
    }
    return roots;
  }

  function initAll(scope) {
    rootsInside(scope || document).forEach(initRoot);
  }

  function destroyAll(scope) {
    rootsInside(scope || document).forEach(function (root) {
      if (root._fkcInstance && typeof root._fkcInstance.destroy === "function") {
        root._fkcInstance.destroy();
      }
    });
  }

  window[API_NAME] = {
    version: API_VERSION,
    initAll: initAll,
    destroyAll: destroyAll
  };

  if (window.__fantastickConfiguratorHandlers) {
    Object.keys(window.__fantastickConfiguratorHandlers).forEach(function (eventName) {
      document.removeEventListener(eventName, window.__fantastickConfiguratorHandlers[eventName]);
    });
  }

  var globalHandlers = {
    "shopify:section:load": function (event) {
      initAll(event.target);
    },
    "shopify:section:unload": function (event) {
      destroyAll(event.target);
    },
    "shopify:block:select": function (event) {
      var chip = event.target && event.target.closest
        ? event.target.closest("[data-fkc-editor-fabric-key]")
        : null;
      if (!chip) return;
      var root = chip.closest(ROOT_SELECTOR);
      if (root && root._fkcInstance) root._fkcInstance.activateFabric(chip.dataset.fkcEditorFabricKey);
    }
  };

  window.__fantastickConfiguratorHandlers = globalHandlers;
  Object.keys(globalHandlers).forEach(function (eventName) {
    document.addEventListener(eventName, globalHandlers[eventName]);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
})();
